(
<template>
<section class="CommonIcons">

  <!-- brand variants -->

  <svg id="icon-brand-fh" viewBox="0 0 181.281 20" style="enable-background: new 0 0 181.281 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-brand-fh content-icon-brand-fh">

    <title id="title-icon-brand-fh">Frankhood</title>
    <desc id="content-icon-brand-fh">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path fill="var(--brand-color-secondary)" d="M0,24.284,6.735,17.6l2.254,2.3L4.609,24.181,9.3,28.714,6.889,31.1Z" transform="translate(0 -13.093)" />
    <path fill="var(--brand-color-primary)" d="M57.7,22.318V4.7H68.865V7.978H61.106V11.87h7.068v3.278H61.106v7.17Z" transform="translate(-42.924 -3.496)" />
    <path fill="var(--brand-color-primary)" d="M115.1,33.7v-3.15h3.3V23.508h-3v-3.15h6.172v.666A2.96,2.96,0,0,1,123.756,20a3.6,3.6,0,0,1,2.714,1.28,5.651,5.651,0,0,1,1.28,3.79l-3.175.512c-.154-1.639-.743-2.433-1.716-2.433-.871,0-1.178.512-1.178.9v6.53h4.763v3.15H115.1Z" transform="translate(-85.625 -14.878)" />
    <path fill="var(--brand-color-primary)" d="M175.456,24.4a4.419,4.419,0,0,1,1.767-3.227,6.108,6.108,0,0,1,7.247.026,3.779,3.779,0,0,1,1.562,3.15V30.4c0,.384.256.563.743.563l.487-.077.538,2.638a4,4,0,0,1-2.023.589,3.31,3.31,0,0,1-1.946-.691l-.256-.23a5.258,5.258,0,0,1-3.2.9c-3.124,0-5.173-1.665-5.173-4.3,0-2.689,1.793-3.713,5.378-4.2,1.434-.2,2.151-.461,2.151-1.152,0-.845-.615-1.28-1.818-1.28-1.408,0-2.2.384-2.407,1.767Zm7.3,3.15-.051.051a3.132,3.132,0,0,1-1.46.461,7.929,7.929,0,0,0-1.921.435,1.144,1.144,0,0,0-.819,1.178c0,.819.717,1.255,2.151,1.255a3.851,3.851,0,0,0,.743-.077c.589-.1,1.357-.589,1.357-1.306Z" transform="translate(-130.334 -14.878)" />
    <path fill="var(--brand-color-primary)" d="M239.2,33.7V20.359h3.175v.666A4.044,4.044,0,0,1,245.167,20a4.845,4.845,0,0,1,3.764,1.613,5.668,5.668,0,0,1,1.46,4.02v8.092h-3.278V25.531a2.132,2.132,0,0,0-2.33-2.382,2.022,2.022,0,0,0-2.3,2.177v8.4H239.2Z" transform="translate(-177.945 -14.878)" />
    <path fill="var(--brand-color-primary)" d="M302.7,22.318V4.7h3.278v8.835l3.79-4.558h3.918l-4.1,4.917,4.814,8.425h-3.534l-3.406-5.941-1.511,1.844v4.1Z" transform="translate(-225.184 -3.496)" />
    <path fill="var(--brand-color-primary)" d="M357.8,22.318V4.7h3.406v6.735h6.044V4.7h3.406V22.318h-3.406V14.687h-6.044v7.631Z" transform="translate(-266.174 -3.496)" />
    <path fill="var(--brand-color-primary)" d="M426.464,34.085a5.379,5.379,0,0,1-4.277-1.844,7.786,7.786,0,0,1-1.588-5.2,7.713,7.713,0,0,1,1.588-5.173A5.4,5.4,0,0,1,426.464,20a5.31,5.31,0,0,1,4.251,1.869,7.586,7.586,0,0,1,1.613,5.173,7.658,7.658,0,0,1-1.613,5.2A5.291,5.291,0,0,1,426.464,34.085Zm0-3.15a2.25,2.25,0,0,0,1.972-.9,5.37,5.37,0,0,0,.64-3,5.217,5.217,0,0,0-.64-2.971,2.124,2.124,0,0,0-1.972-.922,2.253,2.253,0,0,0-2,.922,5.467,5.467,0,0,0-.615,2.971,5.63,5.63,0,0,0,.615,3A2.329,2.329,0,0,0,426.464,30.935Z" transform="translate(-312.892 -14.878)" />
    <path fill="var(--brand-color-primary)" d="M487.464,34.085a5.379,5.379,0,0,1-4.277-1.844,7.786,7.786,0,0,1-1.588-5.2,7.713,7.713,0,0,1,1.588-5.173A5.4,5.4,0,0,1,487.464,20a5.31,5.31,0,0,1,4.251,1.869,7.586,7.586,0,0,1,1.613,5.173,7.658,7.658,0,0,1-1.613,5.2A5.362,5.362,0,0,1,487.464,34.085Zm0-3.15a2.25,2.25,0,0,0,1.972-.9,5.37,5.37,0,0,0,.64-3,5.217,5.217,0,0,0-.64-2.971,2.124,2.124,0,0,0-1.972-.922,2.253,2.253,0,0,0-2,.922,5.467,5.467,0,0,0-.615,2.971,5.63,5.63,0,0,0,.615,3A2.3,2.3,0,0,0,487.464,30.935Z" transform="translate(-358.271 -14.878)" />
    <path fill="var(--brand-color-primary)" d="M548.314,22.318v-.64l-.384.307a6.716,6.716,0,0,1-1.076.435,4.535,4.535,0,0,1-1.639.307,5.432,5.432,0,0,1-4.3-1.844,7.658,7.658,0,0,1-1.613-5.2,7.587,7.587,0,0,1,1.613-5.173,5.452,5.452,0,0,1,4.3-1.869,5.532,5.532,0,0,1,2.689.64l.307.23V4.7h3.278V22.318Zm-.077-7.913a2.556,2.556,0,0,0-2.868-2.638c-1.9,0-2.766,1.178-2.766,3.892s.871,3.892,2.766,3.892a2.587,2.587,0,0,0,2.868-2.663Z" transform="translate(-401.195 -3.496)" />
    <path fill="var(--brand-color-secondary)" d="M604.6,19.129,613.665,0l2.049.922L606.649,20Z" transform="translate(-449.773)" />
    <path fill="var(--brand-color-secondary)" d="M671.7,28.714l4.686-4.533-4.4-4.277,2.254-2.3,6.735,6.684L674.107,31.1Z" transform="translate(-499.69 -13.093)" />
  </svg>

  <svg id="icon-brand-fh-small" viewBox="0 0 72.281 20" style="enable-background: new 0 0 72.281 20" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-brand-fh-small content-icon-brand-fh-small">
    <title id="title-icon-brand-fh-small">Frankhood</title>
    <desc id="content-icon-brand-fh-small">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path fill="var(--brand-color-secondary)" d="M0,24.284,6.735,17.6l2.254,2.3L4.609,24.181,9.3,28.714,6.889,31.1Z" transform="translate(0 -13.093)" />
    <path fill="var(--brand-color-primary)" d="M57.7,22.318V4.7H68.865V7.978H61.106V11.87h7.068v3.278H61.106v7.17Z" transform="translate(-42.924 -3.496)" />
    <path fill="var(--brand-color-primary)" d="M357.8,22.318V4.7h3.406v6.735h6.044V4.7h3.406V22.318h-3.406V14.687h-6.044v7.631Z" transform="translate(-328.174 -3.496)" />
    <path fill="var(--brand-color-secondary)" d="M604.6,19.129,613.665,0l2.049.922L606.649,20Z" transform="translate(-558.772)" />
    <path fill="var(--brand-color-secondary)" d="M671.7,28.714l4.686-4.533-4.4-4.277,2.254-2.3,6.735,6.684L674.107,31.1Z" transform="translate(-608.689 -13.093)" />
  </svg>

  <!-- social icons -->

  <svg id="icon-social-facebook" viewBox="0 0 256 512" style="enable-background: new 0 0 256 512" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-social-facebook content-icon-social-facebook">
    <path fill="var(--social-link-primary)" d="M344.28,85H391V3.61C383,2.5,355.22,0,322.93,0c-67.4,0-113.56,42.39-113.56,120.3V192H135v91h74.37V512h91.18V283h71.36l11.32-91h-82.7V129.3c0-26.3,7.1-44.31,43.75-44.31Z" transform="translate(-135)" />
  </svg>

  <svg id="icon-social-linkedin" viewBox="0 0 682.66669 682" style="enable-background: new 0 0 682.66669 682" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-social-linkedin content-icon-social-linkedin">
    <path fill="var(--social-link-primary)" d="m77.613281-.667969c-46.929687 0-77.613281 30.816407-77.613281 71.320313 0 39.609375 29.769531 71.304687 75.8125 71.304687h.890625c47.847656 0 77.625-31.695312 77.625-71.304687-.894531-40.503906-29.777344-71.320313-76.714844-71.320313zm0 0" />
    <path fill="var(--social-link-primary)" d="m8.109375 198.3125h137.195313v412.757812h-137.195313zm0 0" />
    <path fill="var(--social-link-primary)" d="m482.054688 188.625c-74.011719 0-123.640626 69.546875-123.640626 69.546875v-59.859375h-137.199218v412.757812h137.191406v-230.5c0-12.339843.894531-24.660156 4.519531-33.484374 9.917969-24.640626 32.488281-50.167969 70.390625-50.167969 49.644532 0 69.5 37.851562 69.5 93.339843v220.8125h137.183594v-236.667968c0-126.78125-67.6875-185.777344-157.945312-185.777344zm0 0" />
  </svg>

  <svg id="icon-social-instagram" viewBox="0 0 512 512" style="enable-background: new 0 0 512 512" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-social-instagram content-icon-social-instagram">
    <path fill="var(--social-link-primary)" d="M352,0H160A160,160,0,0,0,0,160V352A160,160,0,0,0,160,512H352A160,160,0,0,0,512,352V160A160,160,0,0,0,352,0ZM464,352A112.12,112.12,0,0,1,352,464H160A112.12,112.12,0,0,1,48,352V160A112.12,112.12,0,0,1,160,48H352A112.12,112.12,0,0,1,464,160ZM256,128A128,128,0,1,0,384,256,128,128,0,0,0,256,128Zm0,208a80,80,0,1,1,80-80A80.11,80.11,0,0,1,256,336ZM410.66,118.4a17.06,17.06,0,1,1-17.06-17.06A17.06,17.06,0,0,1,410.66,118.4Z" />
  </svg>

  <!-- services icons -->

  <svg id="icon-ai-and-machine-learning" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-ai-and-machine-learning content-icon-ai-and-machine-learning">

    <title id="title-icon-ai-and-machine-learning">Ai and Machine Learning Icon</title>
    <desc id="content-icon-ai-and-machine-learning">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path class="shape-0" d="M188.7,377.4c-7.5,1.3-12.4,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5c7.5-1.3,12.4-8.6,11.1-16.3
        C203.3,381.2,196.2,376.1,188.7,377.4z" />
    <path class="shape-1" d="M280.4,371.5c-6.5,1.2-10.9,7.5-9.7,14.2c1.2,6.7,7.4,11.2,14,10c6.5-1.2,10.9-7.5,9.7-14.2
        C293.2,374.8,287,370.3,280.4,371.5z" />
    <path class="shape-0" d="M298.2,309.6c-7.5,1.3-12.5,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5c7.5-1.3,12.4-8.6,11.1-16.3
        C312.9,313.4,305.7,308.3,298.2,309.6z" />
    <path class="shape-2" d="M253.8,347.3c-5.6-1-9.3-6.5-8.3-12.2c1-5.7,6.4-9.6,12-8.6c5.6,1,9.3,6.5,8.3,12.2
        C264.8,344.5,259.4,348.3,253.8,347.3z" />
    <path class="shape-2" d="M230.8,389c-7.5,1.3-12.4,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5c7.5-1.3,12.4-8.6,11.1-16.3
        C245.4,392.8,238.3,387.6,230.8,389z" />
    <path class="shape-3" d="M231.2,359.3c-3.7,0.7-6.2,4.3-5.5,8.1c0.7,3.8,4.2,6.4,8,5.7c3.7-0.7,6.2-4.3,5.5-8.1
        C238.5,361.2,235,358.6,231.2,359.3z" />
    <path class="shape-2" d="M326.6,274c-7.5,1.3-12.4,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5c7.5-1.3,12.4-8.6,11.1-16.3
        C341.3,277.8,334.1,272.7,326.6,274z" />
    <path class="shape-3" d="M331.4,338c-6.5,1.2-10.9,7.5-9.7,14.2c1.2,6.7,7.4,11.2,14,10c6.5-1.2,10.9-7.5,9.7-14.2
        C344.2,341.4,338,336.9,331.4,338z" />
    <path class="shape-0" d="M359.7,229.5c-9.3,1.7-15.6,10.8-13.9,20.3c1.7,9.6,10.6,16,20,14.3
        c9.3-1.7,15.6-10.8,13.9-20.3C378,234.3,369.1,227.9,359.7,229.5z" />
    <path class="shape-4" d="M324.4,194.3c-9.3,1.7-15.6,10.8-13.9,20.3c1.7,9.6,10.6,16,20,14.3
        c9.3-1.7,15.6-10.8,13.9-20.3C342.7,199.1,333.7,192.7,324.4,194.3z" />
    <path class="shape-3" d="M360.2,148.3c-11.2,2-18.7,12.9-16.7,24.4c2,11.5,12.7,19.2,24,17.2
        c11.2-2,18.7-12.9,16.7-24.4C382.2,154,371.5,146.4,360.2,148.3z" />
    <path class="shape-2" d="M408.1,193.3c8.3,0.9,14,5.6,16.5,14.6c1.7,9.6-4.5,18.7-13.9,20.4c-9.3,1.7-18.3-4.8-20-14.3
        c-1.7-9.6,4.5-18.7,13.9-20.4L408.1,193.3z" />
    <path class="shape-0" d="M372.2,287.6c-7.5,1.3-12.4,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5
        c7.5-1.3,12.4-8.6,11.1-16.3C386.8,291.4,379.7,286.3,372.2,287.6z" />
    <path class="shape-0" d="M370.8,89.4c-6.5,1.2-10.9,7.5-9.7,14.2c1.2,6.7,7.4,11.2,14,10c6.5-1.2,10.9-7.5,9.7-14.2
        C383.6,92.7,377.3,88.2,370.8,89.4z" />
    <path class="shape-4" d="M261.8,132.2c-11.2,2-18.7,12.9-16.7,24.4c2,11.5,12.7,19.2,24,17.2
        c11.2-2,18.7-12.9,16.7-24.4C283.8,137.9,273.1,130.2,261.8,132.2z" />
    <path class="shape-3" d="M284.8,178.6c-6.2,1-10.3,6.4-9.2,12.2c1.1,5.7,7.1,9.6,13.3,8.6c6.2-1,10.3-6.4,9.2-12.2
        C296.9,181.4,291,177.6,284.8,178.6z" />
    <path class="shape-1" d="M292.3,258.4c-7.5,1.3-12.4,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5
        c7.5-1.3,12.5-8.6,11.1-16.3C307,262.2,299.8,257,292.3,258.4z" />
    <path class="shape-4" d="M205.1,77.1c-14,2.5-23.3,16.2-20.8,30.5c2.5,14.4,15.9,24,30,21.5s23.3-16.2,20.8-30.5
        C232.6,84.3,219.2,74.6,205.1,77.1z" />
    <path class="shape-4" d="M290.4,80.1c-11.2,2-18.7,12.9-16.7,24.4c2,11.5,12.7,19.2,24,17.2c11.2-2,18.7-12.9,16.7-24.4
        C312.3,85.8,301.6,78.1,290.4,80.1z" />
    <path class="shape-2" d="M155.5,398.9c-5.6,1-9.3,6.5-8.3,12.2c1,5.7,6.4,9.6,12,8.6c5.6-1,9.3-6.5,8.3-12.2
        C166.5,401.7,161.1,397.9,155.5,398.9z" />
    <path class="shape-0" d="M117.9,402.3c-5.6,1-9.3,6.5-8.3,12.2c1,5.7,6.4,9.6,12,8.6c5.6-1,9.3-6.5,8.3-12.2
        C128.9,405.1,123.5,401.3,117.9,402.3z" />
    <path class="shape-5" d="M362.9,118.9c-3.8,0.7-6.3,4.1-5.6,7.6c0.7,3.6,4.4,5.9,8.2,5.3c3.8-0.6,6.3-4.1,5.6-7.6
        C370.3,120.6,366.7,118.2,362.9,118.9z" />
    <path class="shape-5" d="M411.5,165c4.7-0.8,9.1,2.4,10,7.2c0.8,4.8-2.3,9.3-6.9,10.2c-4.7,0.8-9.1-2.4-10-7.2
        C403.7,170.4,406.8,165.8,411.5,165z" />
    <path class="shape-2" d="M315.9,165.4c-3.8,0.7-6.3,4.1-5.6,7.6c0.7,3.6,4.4,5.9,8.2,5.3c3.8-0.7,6.3-4.1,5.6-7.6
        C323.3,167.1,319.7,164.8,315.9,165.4z" />
    <path class="shape-4" d="M295.2,223.8c-3.7,0.7-6.2,4.3-5.5,8.1c0.7,3.8,4.2,6.4,8,5.7c3.7-0.7,6.2-4.3,5.5-8.1
        C302.6,225.8,299,223.2,295.2,223.8z" />
    <path class="shape-4" d="M367.9,204.5c-4.7,0.9-7.7,5.4-6.9,10.2c0.9,4.8,5.4,8,10,7.1c4.7-0.9,7.7-5.4,6.9-10.2
        C377,206.8,372.5,203.6,367.9,204.5z" />
    <path class="shape-4" d="M346.3,311.5c-3.7,0.7-6.2,4.4-5.5,8.2c0.7,3.8,4.3,6.4,8,5.7c3.7-0.7,6.2-4.4,5.5-8.2
        C353.6,313.3,350,310.8,346.3,311.5z" />
    <path class="shape-5" d="M254.4,102.6c-3.7,0.7-6.2,4.4-5.5,8.2c0.7,3.8,4.3,6.4,8,5.7c3.7-0.7,6.2-4.4,5.5-8.2
        C261.7,104.4,258.1,101.9,254.4,102.6z" />
    <path class="shape-3" d="M277,302.2c-3.5,0.5-5.7,3.6-5.1,6.8c0.6,3.2,3.9,5.3,7.4,4.8c3.5-0.6,5.7-3.6,5.1-6.8
        C283.8,303.8,280.5,301.7,277,302.2z" />
    <path class="shape-4" d="M292.5,346.9c-3.7,0.7-6.2,4.3-5.5,8.1c0.7,3.8,4.2,6.4,8,5.7c3.7-0.7,6.2-4.3,5.5-8.1
        C299.8,348.8,296.3,346.3,292.5,346.9z" />
    <path class="shape-2" d="M85,424.9c3.7-0.7,6.2-4.3,5.6-8.1c-0.7-3.8-4.3-6.4-8-5.7c-3.7,0.7-6.2,4.3-5.6,8.1
        C77.7,423,81.3,425.6,85,424.9z" />
    <path class="shape-3" d="M403.2,262.6c4.7-0.7,8.1-5.2,7.5-10c-0.6-4.8-4.9-8.1-9.6-7.5c-4.7,0.7-8.1,5.2-7.5,10
        C394.2,260,398.5,263.3,403.2,262.6z" />
    <path class="shape-3" d="M407.4,125.8c7.3,2,4.8,0,8.6,4.4c2.4,4.2,1.1,9.6-3,12c-4.1,2.4-9.4,0.9-11.8-3.3c-2.4-4.2-1.1-9.6,3-12
        L407.4,125.8z" />
    <path class="shape-1" d="M313.6,129.7c-7.5,1.3-12.5,8.6-11.1,16.3c1.3,7.7,8.5,12.8,16,11.5
        c7.5-1.3,12.4-8.6,11.1-16.3C328.2,133.5,321.1,128.4,313.6,129.7z" />
    <path class="shape-4" d="M326.1,249.4c-3.7,0.7-6.2,4.3-5.6,8.1c0.7,3.8,4.2,6.4,8,5.7c3.7-0.7,6.2-4.3,5.6-8.1
        C333.4,251.3,329.8,248.7,326.1,249.4z" />
    <path class="shape-4" d="M334.8,82.3c-2.8,0.5-4.7,3.2-4.2,6.1c0.5,2.9,3.2,4.8,6,4.3c2.8-0.5,4.7-3.2,4.2-6.1
        C340.3,83.7,337.6,81.8,334.8,82.3z" />
    <path class="shape-4" d="M337.1,116.7c-4.7,0.9-7.7,5.5-6.9,10.2c0.9,4.8,5.4,8,10,7.1c4.7-0.9,7.7-5.5,6.9-10.2
        C346.3,119,341.8,115.8,337.1,116.7z" />
  </svg>

  <svg id="icon-cloud-service" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-cloud-service content-icon-cloud-service">

    <title id="title-icon-cloud-service">Cloud Service Icon</title>
    <desc id="content-icon-cloud-service">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path class="shape-0" d="M118.3,334.7l2,0.4c8.9,3.9,18.6,5.8,28.7,5.8l1.1,0.3l-1.7,4.9c-11.9-0.6-24.5-1.9-34.8-8.5
        C114.5,335.6,116.3,335.4,118.3,334.7z M79.6,293.8c4.2,2,2.9,0.5,4.7,3.5c3.3,9.1,8.7,17.4,15.8,24.2c2.2,2.8,2.2,4.2,0.3,7.1
        C89.9,319.5,81,307.9,78,294.1L79.6,293.8z M87.1,238.7c2.8,2,2.5,4,1.6,6.8c-4.8,8.5-7.6,17.9-8,27.7c-0.3,3.1-2.3,4.5-5.2,5
        l-0.1-2C75.4,262.8,79.3,249.7,87.1,238.7z M134.2,207.9c0.6,3.1-1.3,4.7-3.7,5.9c-9.6,2.6-18.4,7.1-26,13.2
        c-2.8,1.8-4.4,1.7-7-0.4C107.3,216.2,120.5,210.5,134.2,207.9z M150.2,206.1c8.7-0.3,17.3,1.1,25.8,2.8l-1,5.1l-0.2,0
        c-6.2-1.5-12.7-2.3-19.6-2.6C152,211.1,150.7,209.1,150.2,206.1z" />
    <path class="shape-0" d="M303.1,182.2c8.9,10,12.6,20.6,14.6,33.6l-4.6,2l-0.3-1.6c-1.5-9.7-5.3-19-10.8-27.1
        C300.5,186.3,300.8,184.5,303.1,182.2z M187.3,179.7c2.5,2.5,2,4.3,0.6,7c-6.1,7.3-10.2,18.4-12.5,27.5l-4.7-2.4
        C172.9,199.6,178.9,188.7,187.3,179.7z M254,154.8c13.9,1.7,27.4,6.7,38,16c-2.4,2.7-4.2,2.2-7,1c-7.9-5.6-17.1-9.4-26.8-11.3
        C255.2,159.8,254,157.7,254,154.8z M238.3,154.4c0.3,3.3-1.6,4.8-4.4,5.8c-9.8,1.5-19.3,5-27.6,10.2c-2.9,1.4-4.8,0.9-7-1.5
        C210.3,160.8,224.5,155.1,238.3,154.4z" />
    <path class="shape-0" d="M352.4,346l-2.4-4.2l-0.5-0.9 M347.2,341.1c9.5,0,18.7-3.7,27.2-7.2l2-0.4c2.6,1,3.2,0.7,4.7,3
        c-10.7,5.7-15.8,8.9-27.7,9.5 M415.9,293.4l1.7,0.3c-3,14.2-13.1,24.6-23.1,34.2c-2.2-3-1.5-4.5,0.4-7.2
        c7.2-6.7,12.8-14.9,16.3-23.9C413,293.9,411.6,295.3,415.9,293.4z M409.5,237.9c8,10.5,10.4,23.7,11.1,36.5l-0.2,3.2
        c-3.2-0.1-4.5-2.2-5.1-5c-0.3-9.8-2.9-19.3-7.6-27.8C406.5,241.8,407.1,240,409.5,237.9z M362.9,206.4
        c14.1,2.1,26.2,9.7,36.4,19.3c-2.6,2.4-4.3,1.8-7,0.3c-7.4-6.3-16.2-10.9-25.7-13.6C363.9,211.5,362.7,209,362.9,206.4z
        M346.8,204.4l0.5,0c0,3.3-2,4.6-4.8,5.4c-9.8,0.7-20.2,3.4-28.5,7.5l-1,0.4l-0.9-5.1C322.5,207.5,335.2,204.5,346.8,204.4z" />
    <path class="shape-1" d="M148.3,343.5h205.9" />
    <path class="shape-2" d="M190.6,304.3c-16.3,0-29.5-12.6-29.5-28s13.2-28,29.5-28s29.5,12.6,29.5,28S206.9,304.3,190.6,304.3z" />
    <path class="shape-3" d="M244.1,217.8c-9.8,0-17.7-7.1-17.7-15.8s7.9-15.8,17.7-15.8c9.8,0,17.7,7.1,17.7,15.8
        S253.9,217.8,244.1,217.8z" />
    <path class="shape-4" d="M303.1,304.3c-16.3-0.4-29.2-13.3-28.8-28.8c0.4-15.5,13.9-27.7,30.2-27.3c16.3,0.4,29.2,13.3,28.8,28.8
        C332.9,292.5,319.3,304.7,303.1,304.3z" />
    <path class="shape-5" d="M247.8,318.3c-24.4,0-44.2-18.8-44.2-42.1s19.8-42.1,44.2-42.1c24.4,0,44.2,18.8,44.2,42.1
        S272.2,318.3,247.8,318.3z" />
  </svg>

  <svg id="icon-digital-marketing-solutions" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-digital-marketing-solutions content-icon-digital-marketing-solutions">

    <title id="title-icon-digital-marketing-solutions">Digital Marketing Solutions Icon</title>
    <desc id="content-icon-digital-marketing-solutions">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <line class="shape-0" x1="337.9" y1="161.6" x2="353.9" y2="145.6" />
    <line class="shape-0" x1="306.1" y1="193.4" x2="322.1" y2="177.4" />
    <line class="shape-0" x1="274.3" y1="225.3" x2="290.3" y2="209.2" />
    <line class="shape-0" x1="247.8" y1="251.7" x2="258.5" y2="241" />
    <line class="shape-0" x1="157.7" y1="341.7" x2="141.7" y2="357.8" />
    <line class="shape-0" x1="189.5" y1="309.9" x2="173.5" y2="326" />
    <line class="shape-0" x1="221.3" y1="278.1" x2="205.4" y2="294.2" />
    <line class="shape-0" x1="247.9" y1="251.6" x2="237.2" y2="262.3" />
    <line class="shape-1" x1="247.9" y1="169.3" x2="247.8" y2="145.7" />
    <line class="shape-0" x1="247.9" y1="214.3" x2="247.8" y2="191.6" />
    <line class="shape-0" x1="247.8" y1="251.8" x2="247.8" y2="236.6" />
    <line class="shape-0" x1="247.8" y1="334.1" x2="247.8" y2="356.7" />
    <line class="shape-0" x1="247.8" y1="289.1" x2="247.8" y2="311.7" />
    <line class="shape-0" x1="247.8" y1="251.6" x2="247.8" y2="266.8" />
    <line class="shape-0" x1="157.8" y1="161.6" x2="141.7" y2="145.6" />
    <line class="shape-0" x1="189.6" y1="193.4" x2="173.5" y2="177.4" />
    <line class="shape-0" x1="221.4" y1="225.2" x2="205.3" y2="209.2" />
    <line class="shape-0" x1="247.9" y1="251.7" x2="237.2" y2="241" />
    <line class="shape-0" x1="337.9" y1="341.8" x2="353.9" y2="357.8" />
    <line class="shape-0" x1="306.1" y1="310" x2="322.1" y2="326" />
    <line class="shape-0" x1="274.3" y1="278.2" x2="290.3" y2="294.1" />
    <line class="shape-0" x1="247.8" y1="251.6" x2="258.5" y2="262.3" />
    <line class="shape-2" x1="329.5" y1="251.7" x2="357.3" y2="251.7" />
    <line class="shape-0" x1="284.5" y1="251.7" x2="307.1" y2="251.7" />
    <line class="shape-0" x1="247" y1="251.7" x2="262.1" y2="251.7" />
    <line class="shape-0" x1="166.2" y1="251.7" x2="143.5" y2="251.7" />
    <line class="shape-0" x1="211.2" y1="251.7" x2="188.5" y2="251.7" />
    <line class="shape-0" x1="248.6" y1="251.7" x2="233.5" y2="251.7" />
    <path class="shape-3" d="M389.8,287.1c-19.4,0-35.2-15.7-35.2-35.2c0-19.4,15.7-35.2,35.2-35.2c19.4,0,35.2,15.7,35.2,35.2
        C425,271.4,409.3,287.1,389.8,287.1z" />
    <path class="shape-4" d="M110.4,287.5c-19.5,0-35.4-15.8-35.4-35.4c0-19.5,15.8-35.4,35.4-35.4s35.4,15.8,35.4,35.4
        C145.7,271.6,129.9,287.5,110.4,287.5z" />
    <path class="shape-5" d="M212.4,354.3h70.7V425h-70.7V354.3z" />
    <path class="shape-6" d="M212.9,145.7L248.2,75l35.4,70.7H212.9z" />
  </svg>

  <svg id="icon-mobile-development" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-mobile-development content-icon-mobile-development">

    <title id="title-icon-mobile-development">Mobile Development Icon</title>
    <desc id="content-icon-mobile-development">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path class="shape-0" d="M219.7,75h60.5c23.2,0,41.9,19.5,41.9,43.5v262.9c0,24-18.8,43.5-41.9,43.5h-60.5c-23.2,0-41.9-19.5-41.9-43.5
        V118.5C177.8,94.5,196.6,75,219.7,75z" />
    <path class="shape-1" d="M250,408c-7.7,0-14-6.3-14-14c0-7.7,6.3-14,14-14c7.7,0,14,6.3,14,14C264,401.7,257.7,408,250,408z" />
    <circle class="shape-2" cx="250" cy="230.6" r="32" />
  </svg>

  <svg id="icon-project-and-product-management" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-project-and-product-management content-icon-project-and-product-management">

    <title id="title-icon-project-and-product-management">Project and Product Management Icon</title>
    <desc id="content-icon-project-and-product-management">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path class="shape-0" d="M250,358c-62.8,0-113.7-50.9-113.7-113.7S187.2,130.5,250,130.5c62.8,0,113.7,50.9,113.7,113.7
        S312.8,358,250,358z" />
    <path class="shape-1" d="M384.8,130.5c-11.6,0-21-9.4-21-21c0-11.6,9.4-21,21-21c11.6,0,21,9.4,21,21
        C405.8,121.1,396.4,130.5,384.8,130.5z" />
    <path class="shape-2" d="M74.6,191.5c0-6,116-116.5,116-116.5l58.9,175L74.6,191.5z" />
    <path class="shape-2" d="M308.9,425c6,0,116.5-116,116.5-116l-175-58.9L308.9,425z" />
  </svg>

  <svg id="icon-quality-assurance" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-quality-assurance content-icon-quality-assurance">

    <title id="title-icon-quality-assurance">Quality Assurance Icon</title>
    <desc id="content-icon-quality-assurance">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path d="M182.8,346.3l2.1,0.1c9.8,2.2,19.9,3.4,30.1,3.4l0,0l0,0c3.9,0,7.8-0.2,11.6-0.5c3.2-0.1,4.8,1.7,5.6,4.5
        c-12.5,1.3-6.7,0.9-17.3,1.2c-12.2-0.3-24.7-1.2-36.4-4.8C179.2,347.9,181,347.4,182.8,346.3z M281.4,332.8c2.9,0.8,3.2,0.3,5,2.6
        c-12.1,7-25,12.9-38.8,15.7c-0.6-3.4,0.9-4.9,3.7-6.3c9.8-2.7,19.2-6.6,28.1-11.4L281.4,332.8z M132.8,322.3l1.9,0.9
        c8.1,6,16.9,11.2,26.2,15.2c2.9,1.6,3.4,3.7,2.7,6.7c-13.1-5-25.3-12.1-36.1-21C129.1,322.3,130.6,322.6,132.8,322.3z M327.2,295.5
        l1.7,0.8c-7.7,11.9-18.3,21.2-29.1,30c-2-3.2-1.3-4.6,0.8-7.3c7.8-6.4,14.9-13.7,21.1-21.8C324.2,295.1,322.5,296.1,327.2,295.5
        L327.2,295.5z M92.8,279.2c4.5,1.2,2.9,0,5.2,2.6c5,8.8,11.1,17,17.9,24.5c2.1,3,1.9,4.4-0.2,7.2c-10.3-9.6-18-21.4-24.7-33.7
        L92.8,279.2z M350,243.8l1.8,0.1c-2.3,13.9-7.9,26.8-14.6,39.1c-3-1.9-2.9-3.9-2.1-6.9c4.6-9,8.2-18.5,10.6-28.4
        C347.2,244.6,346.1,246.2,350,243.8z M75.4,224.3c3.3-0.1,4.7,1.9,5.6,4.7c1,10.1,3.2,20.1,6.5,29.6c0.8,3.2-0.4,5-3.1,6.6
        C78.7,252.2,76.8,238.2,75.4,224.3z M351.9,186.4c2.4,9.3,2.9,19,3.1,28.6c-0.2,9.2,0.1,4.8-0.8,13.2c-3.2-0.4-4.3-2.6-4.7-5.5
        c0.1-2.6,0.2-5.1,0.2-7.8c0-7.6-0.6-15.2-1.9-22.6C347.5,189.3,349.2,187.5,351.9,186.4z M83.2,167.8c3.2,1.3,3.6,3.4,3.3,6.5
        c-3,9.6-5,19.6-5.8,29.7c-0.5,3.2-2.5,4.4-5.5,4.8C75.2,194.6,79.1,181.1,83.2,167.8z M329,134c8.2,11.3,14.7,23.9,18.8,37.3
        c-3.3,0.9-4.9-0.6-6.5-3.1c-3.5-9.5-8.1-18.6-13.7-27C326.1,138,326.7,136.3,329,134z M113.4,118.8c2.5,2.8,2,4.4,0.3,7.2
        c-6.7,7.6-12.5,16-17.3,24.9c-2,2.9-3.8,3.1-7,2.2C95.7,140.6,103.5,128.8,113.4,118.8z M287,94.9c11.7,7.2,23.4,16,32.3,26.7
        c-3.1,2.3-4.5,1.8-7.3-0.2c-7-7.3-14.9-13.8-23.4-19.3C285.8,99.8,285.7,98.1,287,94.9z M160.6,86.2c1.2,3.2-0.2,4.9-2.6,6.7
        c-9.2,4.3-17.8,9.6-25.8,15.9c-3,1.8-4.6,1.5-7.2-0.7C135.4,98.6,147.7,91.6,160.6,86.2z M232.6,76.2c14.1,1.1,27.4,5.9,40.2,11.3
        c-1.6,3-3.7,3.3-6.7,2.7c-9.3-3.8-19.1-6.6-29.2-8.2C233.8,81.3,232.7,79.2,232.6,76.2z M215,75l1.7,0c-0.1,3.3-2.2,4.6-5.1,5.2
        c-10.2,0.2-20.3,1.6-30,4.1c-3.2,0.5-4.9-0.8-6.3-3.6C188.1,76.5,201.6,75.3,215,75z" />
    <path class="shape-0" d="M215,258.8c-24.2,0-43.7-19.6-43.7-43.8s19.6-43.8,43.7-43.8c24.2,0,43.8,19.6,43.8,43.8S239.2,258.8,215,258.8
	    z" />
    <path class="shape-1" d="M316.2,425l-69.9-178.7L425,316.1L316.2,425z" />
    <path class="shape-1" d="M246.3,246.3L425,316.1L316.2,425L246.3,246.3z" />
  </svg>

  <svg id="icon-strategic-consulting" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-strategic-consulting content-icon-strategic-consulting">

    <title id="title-icon-strategic-consulting">Strategic Consulting Icon</title>
    <desc id="content-icon-strategic-consulting">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path class="shape-0" d="M250,425c-6,0-12-0.3-17.9-0.9c-5.8-0.6-11.6-1.5-17.4-2.7c-5.6-1.2-11.3-2.6-16.8-4.3
        c-5.4-1.7-10.8-3.7-16.1-5.9c-5.2-2.2-10.3-4.7-15.3-7.4c-4.9-2.7-9.8-5.6-14.4-8.8c-4.6-3.1-9.2-6.5-13.5-10.1
        c-4.3-3.6-8.5-7.4-12.4-11.3c-3.9-3.9-7.8-8.1-11.3-12.4c-3.6-4.3-7-8.9-10.1-13.5c-3.2-4.7-6.1-9.5-8.8-14.4
        c-2.7-5-5.2-10.1-7.4-15.3c-2.2-5.3-4.2-10.6-5.9-16.1c-1.7-5.5-3.2-11.1-4.3-16.8c-1.2-5.7-2.1-11.6-2.7-17.4
        c-1.2-11.9-1.2-23.9,0-35.8c0.6-5.8,1.5-11.6,2.7-17.4c1.2-5.6,2.6-11.3,4.3-16.8c1.7-5.4,3.7-10.8,5.9-16.1
        c2.2-5.2,4.7-10.3,7.4-15.3c2.7-4.9,5.6-9.8,8.8-14.4c3.1-4.6,6.5-9.2,10.1-13.5c3.6-4.3,7.4-8.5,11.3-12.4
        c3.9-3.9,8.1-7.8,12.4-11.3c4.3-3.6,8.9-7,13.5-10.1c4.6-3.2,9.5-6.1,14.4-8.8c5-2.7,10.1-5.2,15.3-7.4c5.3-2.2,10.6-4.2,16.1-5.9
        c5.5-1.7,11.1-3.2,16.8-4.3c5.7-1.2,11.5-2.1,17.4-2.7c11.9-1.2,23.9-1.2,35.8,0c5.8,0.6,11.6,1.5,17.4,2.7
        c5.6,1.2,11.3,2.6,16.8,4.3c5.4,1.7,10.8,3.7,16.1,5.9c5.2,2.2,10.3,4.7,15.3,7.4c4.9,2.7,9.8,5.6,14.4,8.8
        c4.6,3.1,9.2,6.5,13.5,10.1c4.3,3.6,8.5,7.4,12.4,11.3c3.9,3.9,7.8,8.1,11.3,12.4c3.6,4.3,7,8.9,10.1,13.5c3.2,4.6,6.1,9.5,8.8,14.4
        c2.7,5,5.2,10.1,7.4,15.3c2.2,5.3,4.2,10.6,5.9,16.1c1.7,5.5,3.2,11.1,4.3,16.8c1.2,5.7,2.1,11.6,2.7,17.4c1.2,11.9,1.2,23.9,0,35.8
        c-0.6,5.8-1.5,11.6-2.7,17.4c-1.2,5.6-2.6,11.3-4.3,16.8c-1.7,5.4-3.7,10.8-5.9,16.1c-2.2,5.2-4.7,10.3-7.4,15.3
        c-2.7,4.9-5.6,9.8-8.8,14.4c-3.1,4.6-6.5,9.2-10.1,13.5c-3.6,4.3-7.4,8.5-11.3,12.4c-3.9,3.9-8.1,7.8-12.4,11.3
        c-4.3,3.6-8.9,7-13.5,10.1c-4.6,3.2-9.5,6.1-14.4,8.8c-5,2.7-10.1,5.2-15.3,7.4c-5.3,2.2-10.6,4.2-16.1,5.9
        c-5.5,1.7-11.1,3.2-16.8,4.3c-5.7,1.2-11.6,2.1-17.4,2.7C261.9,424.7,256,425,250,425z M250,132.3c-4,0-8,0.2-12,0.6
        c-55.5,5.6-99.4,49.5-105,105c-0.8,8-0.8,16.1,0,24.1c5.6,55.5,49.5,99.4,105,105c8,0.8,16,0.8,24.1,0c55.5-5.6,99.4-49.5,105-105
        c0.8-8,0.8-16,0-24.1c-5.6-55.5-49.5-99.4-105-105C258,132.6,254,132.3,250,132.3L250,132.3z" />
    <path class="shape-1" d="M372.5,280.6c0.7,67.6-53.6,123.4-121.3,124.6c-67.7,1.2-123-52.7-123.7-120.3
        c-0.7-67.6,53.6-123.4,121.3-124.6C316.4,159.1,371.8,213,372.5,280.6z" />
    <path class="shape-1" d="M369.5,213.7c0.7,67.6-53.6,123.4-121.3,124.6c-67.7,1.2-123-52.7-123.7-120.3
        c-0.7-67.6,53.6-123.4,121.3-124.6C313.5,92.2,368.9,146.1,369.5,213.7z" />
    <path class="shape-2" d="M261.1,190.4c34.5,5.8,57.5,37.1,51.4,70c-6.1,32.9-39.1,54.9-73.6,49.1
        c-34.5-5.8-57.5-37.1-51.4-70C193.6,206.6,226.6,184.7,261.1,190.4z" />
    <path class="shape-3" d="M256.4,211.8c20,3.5,33.3,22.6,29.8,42.7c-3.6,20-22.6,33.4-42.6,29.9
        c-20-3.5-33.3-22.6-29.8-42.7S236.4,208.3,256.4,211.8z" />
    <path class="shape-0" d="M247.5,238.9c-4.8,0.8-8,5.1-7.1,9.6c0.9,4.5,5.6,7.4,10.4,6.6c4.8-0.8,8-5.1,7.1-9.6
        C257,241.1,252.4,238.1,247.5,238.9z" />
  </svg>

  <svg id="icon-web-development" :viewBox="viewbox" :style="`enable-background: new ${viewbox};`" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-web-development content-icon-web-development">
    <title id="title-icon-web-development">Web Development Icon</title>
    <desc id="content-icon-web-development">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path class="shape-0" d="M114,75H386c21.5,0,39,16.5,39,36.9V330c0,20.4-17.4,36.9-39,36.9H114c-21.5,0-39-16.5-39-36.9V111.9
        C75,91.5,92.4,75,114,75z" />
    <circle class="shape-1" cx="250" cy="214.9" r="32.1" />
    <path class="shape-2" d="M96.2,382.5h306.9c11.9,0,21.6,9.4,21.6,21l0,0c0,11.6-9.6,21-21.6,21H96.2c-11.9,0-21.6-9.4-21.6-21l0,0
        C74.6,391.9,84.3,382.5,96.2,382.5z" />
  </svg>

  <!-- approach icons -->

  <svg id="icon-approach-identify" viewBox="0 0 400 399.1" style="enable-background: new 0 0 400 399.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-approach-identify content-icon-approach-identify" class="animation-approach-identify">

    <title id="title-icon-approach-identify">Approach Identify Icon</title>
    <desc id="content-icon-approach-identify">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <g class="shape shape-8">
      <path d="M369,219.89a20,20,0,1,1,20-20A20,20,0,0,1,369,219.89Z" fill="var(--color-yellow)" />
      <path class="pulse pulse-1" d="M369,223.89c-31.54-.56-31.54-47.43,0-48C400.54,176.45,400.54,223.32,369,223.89Z" fill="none" stroke="var(--color-yellow)" stroke-miterlimit="10" stroke-width="2" />
      <path class="pulse pulse-2" d="M339,199.89a30,30 0 1,0 60,0a30,30 0 1,0 -60,0" fill="none" stroke="var(--color-yellow)" stroke-miterlimit="10" stroke-width="2"></path>
    </g>
    <path class="shape shape-7" d="M256,221a20,20,0,1,1,20-20A20,20,0,0,1,256,221Z" fill="var(--color-green)" />
    <path class="shape shape-5" d="M166.71,40a20,20,0,1,1,20-20A20,20,0,0,1,166.71,40Z" fill="var(--color-red)" />
    <path class="shape shape-3" d="M77.86,399.1a20,20,0,1,1,20-20A20,20,0,0,1,77.86,399.1Z" fill="var(--color-purple)" />
    <g>
      <path class="line line-1" d="M27,200.89a3,3,0,0,1-3,3H17a3,3,0,0,1,0-6h7A3,3,0,0,1,27,200.89Z" />
      <path class="line line-2" d="M59.16,200.89a3,3,0,0,1-3,3H38.84a3,3,0,0,1,0-6H56.16A3,3,0,0,1,59.16,200.89Z" />
      <path class="line line-3" d="M81,200.89v7a3,3,0,0,1-6,0v-4H71a3,3,0,0,1,0-6h7A3,3,0,0,1,81,200.89Z" />
      <path class="line line-4" d="M81,219.6v13.67a3,3,0,0,1-6,0V219.6a3,3,0,0,1,6,0Z" />
      <path class="line line-5" d="M81,245v13.67a3,3,0,0,1-6,0V245a3,3,0,0,1,6,0Z" />
      <path class="line line-6" d="M81,270.37V284a3,3,0,0,1-6,0V270.37a3,3,0,0,1,6,0Z" />
      <path class="line line-7" d="M78,292.75a3,3,0,0,0-3,3v13.66a3,3,0,0,0,6,0V295.75A3,3,0,0,0,78,292.75Z" />
      <path class="line line-8" d="M81,321.13v13.66a3,3,0,0,1-6,0V321.13a3,3,0,0,1,6,0Z" />
      <path class="line line-9" d="M81,346.51v13.67a3,3,0,0,1-6,0V346.51a3,3,0,0,1,6,0Z" />
      <path class="line line-10" d="M88,378.89a3,3,0,0,1-3,3H78a3,3,0,0,1-3-3v-7a3,3,0,0,1,6,0v4h4A3,3,0,0,1,88,378.89Z" />
      <path class="line line-11" d="M118.47,378.89a3,3,0,0,1-3,3H99.06a3,3,0,0,1,0-6h16.41A3,3,0,0,1,118.47,378.89Z" />
      <path class="line line-12" d="M148.94,378.89a3,3,0,0,1-3,3H129.53a3,3,0,1,1,0-6h16.41A3,3,0,0,1,148.94,378.89Z" />
      <path class="line line-13" d="M170,371.89v7a3,3,0,0,1-3,3h-7a3,3,0,0,1,0-6h4v-4a3,3,0,0,1,6,0Z" />
      <path class="line line-14" d="M170,346.26v13.8a3,3,0,0,1-6,0v-13.8a3,3,0,0,1,6,0Z" />
      <path class="line line-15" d="M170,320.63v13.8a3,3,0,0,1-6,0v-13.8a3,3,0,0,1,6,0Z" />
      <path class="line line-16" d="M170,295v13.81a3,3,0,0,1-6,0V295a3,3,0,0,1,6,0Z" />
      <path class="line line-17" d="M170,269.38v13.8a3,3,0,0,1-6,0v-13.8a3,3,0,0,1,6,0Z" />
      <path class="line line-18" d="M170,243.75v13.8a3,3,0,0,1-6,0v-13.8a3,3,0,0,1,6,0Z" />
      <path class="line line-19" d="M167,215.12a3,3,0,0,0-3,3v13.8a3,3,0,0,0,6,0v-13.8A3,3,0,0,0,167,215.12Z" />
      <path class="line line-20" d="M167,189.49a3,3,0,0,0-3,3v13.8a3,3,0,0,0,6,0v-13.8A3,3,0,0,0,167,189.49Z" />
      <path class="line line-21" d="M167,163.86a3,3,0,0,0-3,3v13.8a3,3,0,0,0,6,0v-13.8A3,3,0,0,0,167,163.86Z" />
      <path class="line line-22" d="M170,141.23V155a3,3,0,0,1-6,0v-13.8a3,3,0,0,1,6,0Z" />
      <path class="line line-23" d="M170,115.6v13.8a3,3,0,0,1-6,0V115.6a3,3,0,0,1,6,0Z" />
      <path class="line line-24" d="M170,90v13.8a3,3,0,0,1-6,0V90a3,3,0,0,1,6,0Z" />
      <path class="line line-25" d="M170,64.35v13.8a3,3,0,0,1-6,0V64.35a3,3,0,0,1,6,0Z" />
      <path class="line line-26" d="M170,38.72v13.8a3,3,0,1,1-6,0V38.72a3,3,0,0,1,6,0Z" />
      <path class="line line-27" d="M177,19.89a3,3,0,0,1-3,3h-4v4a3,3,0,0,1-6,0v-7a3,3,0,0,1,3-3h7A3,3,0,0,1,177,19.89Z" />
      <path class="line line-28" d="M207.47,19.89a3,3,0,0,1-3,3H188.06a3,3,0,0,1,0-6h16.41A3,3,0,0,1,207.47,19.89Z" />
      <path class="line line-29" d="M237.94,19.89a3,3,0,0,1-3,3H218.53a3,3,0,0,1,0-6h16.41A3,3,0,0,1,237.94,19.89Z" />
      <path class="line line-30" d="M259,19.89v7a3,3,0,0,1-6,0v-4h-4a3,3,0,0,1,0-6h7A3,3,0,0,1,259,19.89Z" />
      <path class="line line-31" d="M259,38.82V52.74a3,3,0,1,1-6,0V38.82a3,3,0,1,1,6,0Z" />
      <path class="line line-32" d="M259,64.66V78.58a3,3,0,0,1-6,0V64.66a3,3,0,1,1,6,0Z" />
      <path class="line line-33" d="M259,90.51v13.92a3,3,0,0,1-6,0V90.51a3,3,0,1,1,6,0Z" />
      <path class="line line-34" d="M259,116.35v13.92a3,3,0,0,1-6,0V116.35a3,3,0,0,1,6,0Z" />
      <path class="line line-35" d="M259,142.2v13.92a3,3,0,0,1-6,0V142.2a3,3,0,0,1,6,0Z" />
      <path class="line line-36" d="M259,168V182a3,3,0,1,1-6,0V168a3,3,0,1,1,6,0Z" />
      <path class="line line-37" d="M266,200.89a3,3,0,0,1-3,3h-7a3,3,0,0,1-3-3v-7a3,3,0,0,1,6,0v4h4A3,3,0,0,1,266,200.89Z" />
      <path class="line line-38" d="M290.78,200.89a3,3,0,0,1-3,3H274.44a3,3,0,0,1,0-6h13.34A3,3,0,0,1,290.78,200.89Z" />
      <path class="line line-39" d="M315.56,200.89a3,3,0,0,1-3,3H299.22a3,3,0,0,1,0-6h13.34A3,3,0,0,1,315.56,200.89Z" />
      <path class="line line-40" d="M334,200.89a3,3,0,0,1-3,3h-7a3,3,0,0,1,0-6h7A3,3,0,0,1,334,200.89Z" />
    </g>
    <g class="shape shape-6">
      <path d="M256.05,36a15,15,0,1,1,15-15A15,15,0,0,1,256.05,36Z" fill="var(--color-red)" />
      <path d="M241.05,21a15,15 0 1,0 30,0a15,15 0 1,0 -30,0" fill="none" stroke="var(--color-green)" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"></path>
    </g>
    <g class="shape shape-4">
      <path d="M167.5,394.12a15,15,0,1,1,15-15A15,15,0,0,1,167.5,394.12Z" fill="var(--color-purple)" />
      <path d="M152.5,379.12a15,15 0 1,0 30,0a15,15 0 1,0 -30,0" fill="none" stroke="var(--color-red)" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"></path>
    </g>
    <g class="shape shape-2">
      <path d="M62.8,200.8a15,15 0 1,0 30,0a15,15 0 1,0 -30,0" fill="var(--color-blue)" stroke="var(--color-blue)" stroke-miterlimit="10"></path>
      <path d="M62.8,200.8a15,15 0 1,0 30,0a15,15 0 1,0 -30,0" fill="none" stroke="var(--color-purple)" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"></path>
    </g>
    <path class="shape shape-1" d="M0,201.39a13.5,13.5 0 1,0 27,0a13.5,13.5 0 1,0 -27,0" fill="var(--color-blue)"></path>
  </svg>

  <svg id="icon-approach-improve" viewBox="0 0 400 400" style="enable-background: new 0 0 400 400" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-approach-improve content-icon-approach-improve" class="animation-approach-improve">
    <title id="title-icon-approach-improve">Approach Improve Icon</title>
    <desc id="content-icon-approach-improve">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <g class="level red">
      <path d="M297.34,118.85A17.24,17.24,0,1,1,280.1,101.6,17.24,17.24,0,0,1,297.34,118.85Z" fill="var(--color-red)" />
      <path d="M136.11,118.85a17.24,17.24,0,1,1-17.23-17.25A17.24,17.24,0,0,1,136.11,118.85Z" fill="var(--color-red)" />
      <path d="M136.07,281.42a17.24,17.24,0,1,1-17.24-17.25A17.25,17.25,0,0,1,136.07,281.42Z" fill="var(--color-red)" />
      <path d="M297.5,281.23A17.24,17.24,0,1,1,280.26,264,17.24,17.24,0,0,1,297.5,281.23Z" fill="var(--color-red)" />
    </g>
    <g class="level purple">
      <path d="M101.43,200a17.24,17.24,0,1,1-17.24-17.25A17.24,17.24,0,0,1,101.43,200Z" fill="var(--color-purple)" />
      <path d="M332,200a17.24,17.24,0,1,1-17.24-17.25A17.24,17.24,0,0,1,332,200Z" fill="var(--color-purple)" />
      <path d="M217.38,315.81a17.24,17.24,0,1,1-17.24-17.25A17.24,17.24,0,0,1,217.38,315.81Z" fill="var(--color-purple)" />
      <path d="M217.22,84.23A17.24,17.24,0,1,1,200,67,17.24,17.24,0,0,1,217.22,84.23Z" fill="var(--color-purple)" />
    </g>
    <g class="level blue">
      <path d="M33.49,366.49V400H0V366.49Z" fill="var(--color-blue)" />
      <path d="M400,366.49V400H366.5V366.49Z" fill="var(--color-blue)" />
      <path d="M400,0V33.52H366.5V0Z" fill="var(--color-blue)" />
      <path d="M33.49,0V33.51H0V0Z" fill="var(--color-blue)" />
    </g>
    <g class="level green">
      <path d="M349.26,315.77v33.51H315.77V315.77Z" fill="var(--color-green)" />
      <path d="M84.13,315.73v33.51H50.64V315.73Z" fill="var(--color-green)" />
      <path d="M349.26,50.78V84.29H315.77V50.78Z" fill="var(--color-green)" />
      <path d="M84.13,50.76V84.27H50.64V50.76Z" fill="var(--color-green)" />
    </g>
    <path class="level yellow" d="M267,200a67,67,0,1,1-67-67A67,67,0,0,1,267,200Z" fill="var(--color-yellow)" />
  </svg>

  <svg id="icon-approach-support" viewBox="0 0 452 452.17" style="enable-background: new 0 0 452 452.17" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-approach-support content-icon-approach-support" class="animation-approach-support">
    <title id="title-icon-approach-support">Approach Support Icon</title>
    <desc id="content-icon-approach-support">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <g class="level-11">
      <path d="M0,399H226.24l30.7,53.17L287.63,399H452V0Zm257-49a20,20,0,1,1,20-20A20,20,0,0,1,257,350Zm112,0a20,20,0,1,1,20-20A20,20,0,0,1,369,350Zm0-101a20,20,0,1,1,20-20A20,20,0,0,1,369,249Z" fill="var(--color-yellow)" />
    </g>
    <path class="level level-1" d="M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20Z" fill="var(--color-blue)" />
    <path class="level level-2" d="M154,20A20,20,0,1,1,134,0,20,20,0,0,1,154,20Z" fill="var(--color-green)" />
    <path class="level level-3" d="M277,20A20,20,0,1,1,257,0,20,20,0,0,1,277,20Z" fill="var(--color-blue)" />
    <path class="level level-4" d="M390,20A20,20,0,1,1,370,0,20,20,0,0,1,390,20Z" fill="var(--color-blue)" />
    <path class="level level-5" d="M40,120a20,20,0,1,1-20-20A20,20,0,0,1,40,120Z" fill="var(--color-green)" />
    <path class="level level-6" d="M277,120a20,20,0,1,1-20-20A20,20,0,0,1,277,120Z" fill="var(--color-green)" />
    <path class="level level-7" d="M40,229a20,20,0,1,1-20-20A20,20,0,0,1,40,229Z" fill="var(--color-blue)" />
    <path class="level level-8" d="M40,330a20,20,0,1,1-20-20A20,20,0,0,1,40,330Z" fill="var(--color-blue)" />
    <path class="level level-9" d="M154,229a20,20,0,1,1-20-20A20,20,0,0,1,154,229Z" fill="var(--color-green)" />
    <path class="level level-10" d="M154,120a20,20,0,1,1-20-20A20,20,0,0,1,154,120Z" fill="var(--color-yellow)" />
    <path d="M134,100a20,20,0,1,1-20,20,20,20,0,0,1,20-20m0-20a40,40,0,1,0,40,40,40,40,0,0,0-40-40Z" fill="var(--color-yellow)" />
  </svg>

  <svg id="icon-approach-tailor" viewBox="0 0 452 448" style="enable-background: new 0 0 452 448" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-approach-tailor content-icon-approach-tailor" class="animation-approach-tailor">
    <title id="title-icon-approach-tailor">Approach Tailor Icon</title>
    <desc id="content-icon-approach-tailor">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path d="M123.8,95.13,152,95C142,60,164,2,226,1c54,0,82,48,71.85,94.13h33.94c12.14,0,22,9.26,22,20.68l-.28,65.69.28-.07h75.7c11.89,0,21.52,13,21.52,29.14v2c0,16.09-10.12,28.47-22,28.47l-75.22-.07v74.84c0,11.42-9.85,20.68-22,20.68h-22.5L380,447H72l72-110.55H120.21c-12.14,0-22-9.26-22-20.68l.28-74.27-76,.17c-11.89,0-21.52-13-21.52-29.14v-2c0-16.09,9.63-29.14,21.52-29.14h75.7V115.81c0-11.42,9.85-20.68,22-20.68" fill="none" stroke="var(--color-black)" stroke-width="2" class="line" />
    <path d="M123.8,95.13,152,95C142,60,164,2,226,1c54,0,82,48,71.85,94.13h33.94c12.14,0,22,9.26,22,20.68l-.28,65.69.28-.07h75.7c11.89,0,21.52,13,21.52,29.14v2c0,16.09-10.12,28.47-22,28.47l-75.22-.07v74.84c0,11.42-9.85,20.68-22,20.68h-22.5L380,447H72l72-110.55H120.21c-12.14,0-22-9.26-22-20.68l.28-74.27-76,.17c-11.89,0-21.52-13-21.52-29.14v-2c0-16.09,9.63-29.14,21.52-29.14h75.7V115.81c0-11.42,9.85-20.68,22-20.68" fill="none" stroke="var(--color-smoke)" stroke-width="4" stroke-dasharray="6 4" stroke-linecap="butt" stroke-linejoin="bevel" />
    <path d="M33.42,190.34H419.58c11.28,0,20.42,8.75,20.42,19.55v1.32c0,10.8-9.14,19.55-20.42,19.55H33.42C22.14,230.76,13,222,13,211.21v-1.32C13,199.09,22.14,190.34,33.42,190.34Z" fill="var(--color-blue)" class="shape shape-blue" />
    <path d="M129.76,103.71H322.24c11.05,0,20,8.57,20,19.15V308c0,10.58-8.95,19.15-20,19.15H129.76c-11,0-20-8.57-20-19.15V122.86C109.76,112.28,118.71,103.71,129.76,103.71Z" fill="var(--color-yellow)" stroke="var(--color-yellow)" stroke-miterlimit="10" class="shape shape-yellow" />
    <path d="M226,140.85a65,65,0,1,1,65-65A65,65,0,0,1,226,140.85Z" fill="var(--color-red)" stroke="var(--color-red)" stroke-miterlimit="10" class="shape-red" />
    <path d="M97.69,434.21,226,221.41l128.31,212.8Z" fill="var(--color-green)" stroke="var(--color-green)" stroke-miterlimit="10" class="shape shape-green" />
  </svg>

  <svg id="icon-approach-understand" viewBox="0 0 425.07 425.07" style="enable-background: new 0 0 425.07 425.07" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-approach-understand content-icon-approach-understand" class="animation-approach-understand">
    <title id="title-icon-approach-understand">Approach Understand Icon</title>
    <desc id="content-icon-approach-understand">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path d="M185.43,360.07A150,150,0,1,1,360.07,239.65,150,150,0,0,1,185.43,360.07Z" fill="none" stroke="var(--color-green)" stroke-linecap="round" stroke-linejoin="round" stroke-width="20" stroke-dasharray="200 140" class="level level-2" />
    <path d="M167.59,301.87a100,100,0,1,1,134.28-44.39A100,100,0,0,1,167.59,301.87Z" fill="none" stroke="var(--color-red)" stroke-linecap="round" stroke-linejoin="round" stroke-width="15" stroke-dasharray="90 75" class="level level-3" />
    <path d="M212.54,262.54a50,50,0,1,1,50-50A50,50,0,0,1,212.54,262.54Z" fill="none" stroke="var(--color-purple)" stroke-linecap="round" stroke-linejoin="round" stroke-width="10" stroke-dasharray="30 20" class="level level-4" />
    <path d="M212.54,225a12.5,12.5,0,1,1,12.5-12.5A12.5,12.5,0,0,1,212.54,225Z" fill="var(--color-blue)" stroke="var(--color-blue)" stroke-miterlimit="10" stroke-width="5" class="level level-5" />
    <path d="M309.61,387.4C213,441,91.28,406.18,37.67,309.61S18.89,91.28,115.47,37.67s218.32-18.78,271.93,77.8S406.18,333.79,309.61,387.4Z" fill="none" stroke="var(--color-yellow)" stroke-linecap="round" stroke-linejoin="round" stroke-width="25" stroke-dasharray="250 175" class="level level-1" />
  </svg>

  <!-- planets -->

  <svg id="icon-planet-dotted" viewBox="0 0 132.7 130.54" style="enable-background: new 0 0 132.7 130.54;" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-planet-dotted content-icon-planet-dotted">
    <title id="title-icon-planet-dotted">Planet Dotted Icon</title>
    <desc id="content-icon-planet-dotted">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path d="M128.87,76.36A64.9,64.9,0,1,1,76.08,1,65.09,65.09,0,0,1,128.87,76.36Z" fill="var(--planet-color-0)" />
    <path d="M99.44,120.47a19.87,19.87,0,0,1,7.11-39.09,19.5,19.5,0,0,1,15.5,14.76A65.42,65.42,0,0,1,99.44,120.47ZM17.62,110.06A19.9,19.9,0,0,0,20.1,70.68,19.46,19.46,0,0,0,1.26,78.14,65.54,65.54,0,0,0,17.62,110.06ZM66.3,50.63A19.69,19.69,0,0,0,89,34.45a19.5,19.5,0,1,0-38.4-6.78A19.69,19.69,0,0,0,66.3,50.63Z" fill="var(--planet-color-1)" />
  </svg>

  <svg id="icon-planet-striped" viewBox="0 0 99.22 99.22" style="enable-background: new 0 0 99.22 99.22;" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-planet-striped content-icon-planet-striped">
    <title id="title-icon-planet-striped">Planet Striped Icon</title>
    <desc id="content-icon-planet-striped">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path d="M99.22,49.61A49.61,49.61,0,1,1,49.61,0,49.61,49.61,0,0,1,99.22,49.61Z" fill="var(--planet-color-0)" />
    <path d="M12.69,16.48c.67-.74,1.36-1.47,2.07-2.17l72.49,67.6c-.65.76-1.33,1.5-2,2.22ZM37.61,97.75a49.56,49.56,0,0,0,10.33,1.43L.26,54.72A49.52,49.52,0,0,0,2.42,64.94ZM1.29,38.38c-.35,1.54-.64,3.1-.85,4.68L59.59,98.22c1.56-.32,3.1-.72,4.6-1.18ZM6.68,24.76C6,26,5.34,27.17,4.75,28.42L73.87,92.88c1.21-.68,2.39-1.4,3.53-2.17ZM41,.76c-1.6.29-3.17.64-4.72,1.07l62,57.78c.32-1.57.57-3.17.74-4.79Zm-14.62,5c-1.23.66-2.43,1.36-3.6,2.12L93.1,73.49c.67-1.21,1.28-2.46,1.85-3.74Zm37.51-3.7A49.7,49.7,0,0,0,53,.12L98.75,42.83A49.17,49.17,0,0,0,96,32.09Z" fill="var(--planet-color-1)" />
  </svg>

  <svg id="icon-planet-solid" viewBox="0 0 66 66" style="enable-background: new 0 0 66 66;" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" preserveAspectRatio="xMinYMid" role="img" aria-labelledby="title-icon-planet-solid content-icon-planet-solid">
    <title id="title-icon-planet-solid">Planet Solid Icon</title>
    <desc id="content-icon-planet-solid">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>

    <path d="M33,0A33,33,0,1,1,0,33,33,33,0,0,1,33,0Z" fill="var(--planet-color-0)" />
  </svg>

  <svg id="bullet-quote-pink" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 141">
    <title id="title-bullet-quote-pink">Bullet Quote Pink icon</title>
    <desc id="content-bullet-quote-pink">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="Raggruppa_293" data-name="Raggruppa 293" transform="translate(-140 -193)">
      <circle id="Ellisse_88" data-name="Ellisse 88" cx="70.5" cy="70.5" r="70.5" transform="translate(140 193)" fill="var(--color-red)" />
      <g id="_" data-name=" " transform="translate(-480.898 -8.281)" style="isolation: isolate">
        <g id="Raggruppa_292" data-name="Raggruppa 292" style="isolation: isolate">
          <path id="Tracciato_386" data-name="Tracciato 386" d="M684.1,272.69V287.1H669.689V274.565a38.112,38.112,0,0,1,1-9.9,10.371,10.371,0,0,1,4.218-5.772q3.223-2.254,9.2-2.432v6.094q-7.032,1.055-7.032,8.731v1.406Zm29,0V287.1H698.693V274.565a39.12,39.12,0,0,1,.971-9.9,10.2,10.2,0,0,1,4.236-5.772q3.266-2.254,9.207-2.432v6.094q-7.031,1.055-7.031,8.731,0,.469.059,1.406Z" fill="var(--color-blue)" />
        </g>
      </g>
    </g>
  </svg>
  <svg id="bullet-quote-green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 141">
    <title id="title-bullet-quote-green">Bullet Quote Green icon</title>
    <desc id="content-bullet-quote-green">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="Raggruppa_293" data-name="Raggruppa 293" transform="translate(-140 -193)">
      <circle id="Ellisse_88" data-name="Ellisse 88" cx="70.5" cy="70.5" r="70.5" transform="translate(140 193)" fill="var(--color-green)" />
      <g id="_" data-name=" " transform="translate(-480.898 -8.281)" style="isolation: isolate">
        <g id="Raggruppa_292" data-name="Raggruppa 292" style="isolation: isolate">
          <path id="Tracciato_386" data-name="Tracciato 386" d="M684.1,272.69V287.1H669.689V274.565a38.112,38.112,0,0,1,1-9.9,10.371,10.371,0,0,1,4.218-5.772q3.223-2.254,9.2-2.432v6.094q-7.032,1.055-7.032,8.731v1.406Zm29,0V287.1H698.693V274.565a39.12,39.12,0,0,1,.971-9.9,10.2,10.2,0,0,1,4.236-5.772q3.266-2.254,9.207-2.432v6.094q-7.031,1.055-7.031,8.731,0,.469.059,1.406Z" fill="var(--color-purple)" />
        </g>
      </g>
    </g>
  </svg>
  <svg id="bullet-quote-blue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 141">
    <title id="title-bullet-quote-blue">Bullet Quote Blue icon</title>
    <desc id="content-bullet-quote-blue">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="Raggruppa_293" data-name="Raggruppa 293" transform="translate(-140 -193)">
      <circle id="Ellisse_88" data-name="Ellisse 88" cx="70.5" cy="70.5" r="70.5" transform="translate(140 193)" fill="var(--color-blue)" />
      <g id="_" data-name=" " transform="translate(-480.898 -8.281)" style="isolation: isolate">
        <g id="Raggruppa_292" data-name="Raggruppa 292" style="isolation: isolate">
          <path id="Tracciato_386" data-name="Tracciato 386" d="M684.1,272.69V287.1H669.689V274.565a38.112,38.112,0,0,1,1-9.9,10.371,10.371,0,0,1,4.218-5.772q3.223-2.254,9.2-2.432v6.094q-7.032,1.055-7.032,8.731v1.406Zm29,0V287.1H698.693V274.565a39.12,39.12,0,0,1,.971-9.9,10.2,10.2,0,0,1,4.236-5.772q3.266-2.254,9.207-2.432v6.094q-7.031,1.055-7.031,8.731,0,.469.059,1.406Z" fill="var(--color-yellow)" />
        </g>
      </g>
    </g>
  </svg>
  <svg id="bullet-quote-purple" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 141">
    <title id="title-bullet-quote-purple">Bullet Quote Purple icon</title>
    <desc id="content-bullet-quote-purple">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="Raggruppa_293" data-name="Raggruppa 293" transform="translate(-140 -193)">
      <circle id="Ellisse_88" data-name="Ellisse 88" cx="70.5" cy="70.5" r="70.5" transform="translate(140 193)" fill="var(--color-purple)" />
      <g id="_" data-name=" " transform="translate(-480.898 -8.281)" style="isolation: isolate">
        <g id="Raggruppa_292" data-name="Raggruppa 292" style="isolation: isolate">
          <path id="Tracciato_386" data-name="Tracciato 386" d="M684.1,272.69V287.1H669.689V274.565a38.112,38.112,0,0,1,1-9.9,10.371,10.371,0,0,1,4.218-5.772q3.223-2.254,9.2-2.432v6.094q-7.032,1.055-7.032,8.731v1.406Zm29,0V287.1H698.693V274.565a39.12,39.12,0,0,1,.971-9.9,10.2,10.2,0,0,1,4.236-5.772q3.266-2.254,9.207-2.432v6.094q-7.031,1.055-7.031,8.731,0,.469.059,1.406Z" fill="var(--color-yellow)" />
        </g>
      </g>
    </g>
  </svg>
  <svg id="bullet-quote-yellow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 141">
    <title id="title-bullet-quote-yellow">Bullet Quote Yellow icon</title>
    <desc id="content-bullet-quote-yellow">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="Raggruppa_293" data-name="Raggruppa 293" transform="translate(-140 -193)">
      <circle id="Ellisse_88" data-name="Ellisse 88" cx="70.5" cy="70.5" r="70.5" transform="translate(140 193)" fill="var(--color-yellow)" />
      <g id="_" data-name=" " transform="translate(-480.898 -8.281)" style="isolation: isolate">
        <g id="Raggruppa_292" data-name="Raggruppa 292" style="isolation: isolate">
          <path id="Tracciato_386" data-name="Tracciato 386" d="M684.1,272.69V287.1H669.689V274.565a38.112,38.112,0,0,1,1-9.9,10.371,10.371,0,0,1,4.218-5.772q3.223-2.254,9.2-2.432v6.094q-7.032,1.055-7.032,8.731v1.406Zm29,0V287.1H698.693V274.565a39.12,39.12,0,0,1,.971-9.9,10.2,10.2,0,0,1,4.236-5.772q3.266-2.254,9.207-2.432v6.094q-7.031,1.055-7.031,8.731,0,.469.059,1.406Z" fill="var(--color-blue)" />
        </g>
      </g>
    </g>
  </svg>
  <svg id="icon-finance" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.5 147.98" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-finance content-icon-finance" class="animation-finance">
    <title id="title-icon-finance">Finance icon</title>
    <desc id="content-icon-finance">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <path id="yellow-box" class="yellow-box" d="M29.76,118.72H5.84a2.16,2.16,0,0,1-2.15-2.15V98.85A2.16,2.16,0,0,1,5.84,96.7H29.76a2.15,2.15,0,0,1,2.15,2.15h0v17.72a2.15,2.15,0,0,1-2.14,2.15h0Z" fill="var(--color-yellow)" />
    <path id="blue-box" class="blue-box" d="M150.62,67.35h23.92a2.15,2.15,0,0,1,2.15,2.15V87.21a2.15,2.15,0,0,1-2.15,2.15H150.62a2.15,2.15,0,0,1-2.15-2.15V69.5a2.15,2.15,0,0,1,2.15-2.15Z" fill="var(--color-blue)" />
    <path id="red-box" class="red-box" d="M66.18,96.25H42.25a2.14,2.14,0,0,1-2.15-2.14V32.91a2.15,2.15,0,0,1,2.15-2.15H66.18a2.15,2.15,0,0,1,2.15,2.15h0v61.2a2.14,2.14,0,0,1-2.15,2.14Z" fill="var(--color-red)" />
    <path id="purple-box" class="purple-box" d="M102.57,48.31H78.65a2.15,2.15,0,0,1-2.15-2.15V20.4a2.15,2.15,0,0,1,2.15-2.15h23.92a2.16,2.16,0,0,1,2.15,2.14h0V46.17a2.15,2.15,0,0,1-2.15,2.15Z" fill="var(--color-purple)" />
    <path id="green-box" class="green-box" d="M139,83.52H115.06a2.14,2.14,0,0,1-2.14-2.15V49.65a2.14,2.14,0,0,1,2.14-2.14H139a2.14,2.14,0,0,1,2.15,2.14V81.37A2.14,2.14,0,0,1,139,83.52h0Z" fill="var(--color-green)" />
    <path id="yellow-bar" class="yellow-bar" d="M17.8,39.6a2.15,2.15,0,0,0-2.15,2.15V137a2.17,2.17,0,0,0,2.15,2.15h0A2.15,2.15,0,0,0,20,137V41.75A2.15,2.15,0,0,0,17.8,39.6Z" fill="var(--color-yellow)" />
    <path id="red-bar" class="red-bar" d="M54.21,1.68a2.16,2.16,0,0,0-2.15,2.15v111a2.14,2.14,0,0,0,2.15,2.14h0a2.14,2.14,0,0,0,2.13-2.15V3.83A2.15,2.15,0,0,0,54.21,1.68Z" fill="var(--color-red)" />
    <path id="purple-bar" class="purple-bar" d="M90.61,1.68a2.15,2.15,0,0,0-2.15,2.15V85.56a2.15,2.15,0,0,0,2.15,2.15h0a2.15,2.15,0,0,0,2.15-2.15V3.83A2.15,2.15,0,0,0,90.61,1.68Z" fill="var(--color-purple)" />
    <path id="green-bar" class="green-bar" d="M127,24.88A2.15,2.15,0,0,0,124.87,27v81.78A2.14,2.14,0,0,0,127,111h0a2.14,2.14,0,0,0,2.14-2.15V27A2.15,2.15,0,0,0,127,24.88Z" fill="var(--color-green)" />
    <path id="blue-bar" class="blue-bar" d="M162.58,47h0a2.15,2.15,0,0,0-2.15,2.15v95.21a2.15,2.15,0,0,0,4.3,0V49.1A2.15,2.15,0,0,0,162.58,47Z" fill="var(--color-blue)" />
  </svg>
  <svg id="icon-retail" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.5 147.98" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-retail content-icon-retail" class="animation-retail">
    <title id="title-icon-retail">Retail icon</title>
    <desc id="content-icon-retail">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="Livello_2" data-name="Livello 2">
      <rect id="purple-box" x="46.43" y="37.36" width="127.79" height="86.76" rx="10.65" fill="var(--color-purple)" class="purple-box" />
      <path id="red-triangle" d="M24.86,0,35.64,18.68,46.43,37.36H3.29L14.07,18.68Z" fill="var(--color-red)" class="red-triangle" />
      <g id="yellow-circle" class="yellow-circle">
        <path id="Tracciato_376" data-name="Tracciato 376" d="M99.13,80.74a11.19,11.19,0,0,0,22.38.21v-.2h0a11.19,11.19,0,0,0-22.38,0Z" fill="var(--color-yellow)" />
      </g>
      <g id="blue-circle" class="blue-circle">
        <path id="Tracciato_377" data-name="Tracciato 377" d="M73,139.12a7.86,7.86,0,1,0,15.71,0h0a7.86,7.86,0,1,0-15.71,0Z" fill="var(--color-blue)" />
      </g>
      <g id="green-circle" class="green-circle">
        <path id="Tracciato_378" data-name="Tracciato 378" d="M131.94,139.12a7.86,7.86,0,0,0,15.71,0h0a7.86,7.86,0,0,0-15.71,0Z" fill="var(--color-green)" />
      </g>
    </g>
  </svg>
  <svg id="icon-industry" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.5 147.98" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-industry content-icon-industry" class="animation-industry">
    <title id="title-icon-industry">Industry icon</title>
    <desc id="content-icon-industry">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="industria">
      <circle id="first-purple-circle" class="first-purple-circle" cx="17.7" cy="116.42" r="12.44" fill="var(--color-purple)" />
      <circle id="green-circle" class="green-circle" cx="132.05" cy="116.42" r="12.44" fill="var(--color-green)" />
      <circle id="red-circle" class="red-circle" cx="90.8" cy="107.37" r="23.58" fill="var(--color-red)" />
      <circle id="yellow-circle" class="yellow-circle" cx="48.5" cy="116.42" r="12.44" fill="var(--color-yellow)" />
      <circle id="purple-circle" class="purple-circle" cx="161.81" cy="116.42" r="12.44" fill="var(--color-purple)" />
      <g id="blue-element" class="blue-element">
        <path id="Rettangolo_156" data-name="Rettangolo 156" d="M90.93,35.24h0a6.29,6.29,0,0,1,6.29,6.29h0a6.29,6.29,0,0,1-6.29,6.3h0a6.3,6.3,0,0,1-6.3-6.3h0A6.3,6.3,0,0,1,90.93,35.24Z" fill="var(--color-blue)" />
        <path id="Tracciato_273" data-name="Tracciato 273" d="M36.46,17H145a4.2,4.2,0,0,1,4.08,4.31A4.2,4.2,0,0,1,145,25.66H36.46a4.19,4.19,0,0,1-4.08-4.32A4.19,4.19,0,0,1,36.46,17Z" fill="var(--color-blue)" />
        <path id="Tracciato_284" data-name="Tracciato 284" d="M58.6,85a4.32,4.32,0,0,1-4.28-4.36A4.27,4.27,0,0,1,54.66,79a38.55,38.55,0,0,1,71.47,0,4.3,4.3,0,0,1-2.28,5.66,4.49,4.49,0,0,1-1.66.35h0a4.19,4.19,0,0,1-3.92-2.58,30,30,0,0,0-55.75,0A4.19,4.19,0,0,1,58.6,85Z" fill="var(--color-blue)" />
      </g>
    </g>
  </svg>
  <svg id="icon-health-care" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-healt-care content-icon-health-care" class="animation-health-care" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217.66 237.12">
    <title id="title-icon-health-care">Health Care icon</title>
    <desc id="content-icon-health-care">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="health-care">
      <ellipse id="small-circle-green-right" cx="141.37" cy="7.87" rx="6.33" ry="6.35" fill="var(--color-green)" class="small-circle" />
      <ellipse id="small-circle-yellow-right" cx="213.46" cy="91.25" rx="2.74" ry="2.74" fill="var(--color-yellow)" class="small-circle" />
      <circle id="big-circle-red" cx="107.95" cy="197.57" r="36.25" transform="translate(-42.51 30.09) rotate(-13.28)" fill="var(--color-red)" class="level big-red-circle" />
      <path id="purple-shape-8" d="M129.65,201.21H86.25a2.42,2.42,0,1,0,0,4.84h43.4a2.42,2.42,0,1,0,0-4.84Z" fill="var(--color-purple)" class="shape" />
      <path id="purple-shape-7" d="M131.37,189.83a2.5,2.5,0,0,0-1.72-.67H86.24a2.42,2.42,0,0,0,0,4.84h43.5a2.42,2.42,0,0,0,1.62-4.17Z" fill="var(--color-purple)" class="shape" />
      <path id="purple-shape-6-left" d="M14.77,168.14a2.43,2.43,0,0,0-1.71-.67H3.82a2.42,2.42,0,0,0-2.37,2.36,2.42,2.42,0,0,0,2.38,2.48h9.33a2.42,2.42,0,0,0,1.69-.75,2.41,2.41,0,0,0-.08-3.42Z" fill="var(--color-purple)" class="shape" />
      <path id="purple-shape-6-right" d="M214.65,168.14a2.45,2.45,0,0,0-1.72-.67H23.08a2.42,2.42,0,0,0-2.37,2.36,2.37,2.37,0,0,0,.67,1.73,2.43,2.43,0,0,0,1.71.75H213a2.43,2.43,0,0,0,1.7-.75,2.46,2.46,0,0,0,.67-1.73A2.41,2.41,0,0,0,214.65,168.14Z" fill="var(--color-purple)" class="shape" />
      <ellipse id="big-circle-green" cx="107.95" cy="125.02" rx="36.25" ry="36.35" fill="var(--color-green)" class="circle big-green-circle" />
      <ellipse id="small-circle-green-left" cx="35.94" cy="112.52" rx="11.36" ry="11.39" fill="var(--color-green)" class="circle" />
      <ellipse id="small-circle-blu-right" cx="181.15" cy="135.56" rx="13.31" ry="13.35" fill="var(--color-blue)" class="circle" />
      <path id="purple-shape-5" d="M178.56,133.13H81.38a2.43,2.43,0,0,0,0,4.85h97.19a2.43,2.43,0,0,0,0-4.85Z" fill="var(--color-purple)" class="shape" />
      <path id="purple-shape-4" d="M134.67,121.13H81.24a2.43,2.43,0,0,0,0,4.86h53.43a2.43,2.43,0,0,0,0-4.86Z" fill="var(--color-purple)" class="shape" />
      <path id="purple-shape-3" d="M133.58,110.09H36.38a2.43,2.43,0,0,0,0,4.85h97.2a2.43,2.43,0,0,0,0-4.85Z" fill="var(--color-purple)" class="shape" />
      <circle id="big-circle-yellow" cx="107.95" cy="52.46" r="36.25" transform="translate(-9.16 26.21) rotate(-13.28)" fill="var(--color-yellow)" class="circle big-yellow-circle" />
      <path id="purple-shape-2" d="M132.83,55.94H83.08a2.42,2.42,0,0,0,0,4.84h49.75a2.42,2.42,0,0,0,0-4.84Z" fill="var(--color-purple)" class="shape" />
      <path id="purple-shape-1" d="M132.83,43.89H83.08a2.42,2.42,0,0,0,0,4.84h49.75a2.42,2.42,0,0,0,0-4.84Z" fill="var(--color-purple)" class="shape" />
      <ellipse id="small-circle-blue-left" cx="26.61" cy="193.31" rx="5.43" ry="5.45" fill="var(--color-blue)" class="small-circle" />
      <ellipse id="small-circle-yellow-left" cx="7.1" cy="93.99" rx="2.74" ry="2.74" fill="var(--color-yellow)" class="small-circle" />
      <ellipse id="small-circle-purple-left" cx="40.37" cy="28.01" rx="2.74" ry="2.74" fill="var(--color-purple)" class="small-circle" />
    </g>
  </svg>
  <svg id="icon-marketing" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-marketing content-icon-marketing" class="animation-marketing" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.5 186.98">
    <title id="title-icon-marketing">Marketing icon</title>
    <desc id="content-icon-marketing">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="marketing">
      <path id="big-circle-yellow" d="M89.82,25.77a66.64,66.64,0,1,0,66.63,66.64A66.64,66.64,0,0,0,89.82,25.77Zm0,124a57.41,57.41,0,1,1,57.4-57.4A57.4,57.4,0,0,1,89.82,149.81Z" fill="var(--color-yellow)" />
      <path id="red-shape" d="M39.22,87.67H7a4.74,4.74,0,0,0,0,9.47H39.22a4.74,4.74,0,1,0,0-9.47Z" fill="var(--color-red)" class="rotate" />
      <path id="green-shape" d="M172.49,87.67H140.28a4.74,4.74,0,0,0,0,9.47h32.21a4.74,4.74,0,0,0,0-9.47Z" fill="var(--color-green)" class="rotate" />
      <path id="purple-shape" d="M89.82,5.22A4.74,4.74,0,0,0,85.08,10v32.2a4.74,4.74,0,0,0,4.74,4.74h0a4.74,4.74,0,0,0,4.73-4.74V10A4.74,4.74,0,0,0,89.82,5.22Z" fill="var(--color-purple)" class="rotate" />
      <path id="blue-shape" d="M89.82,139.07a4.74,4.74,0,0,0-4.74,4.73V176h0a4.74,4.74,0,0,0,4.74,4.73h0A4.72,4.72,0,0,0,94.55,176V143.8A4.73,4.73,0,0,0,89.82,139.07Z" fill="var(--color-blue)" class="rotate" />
      <circle id="small-circle-yellow" cx="89.82" cy="92.41" r="16.68" transform="translate(-13.64 15.58) rotate(-9.22)" fill="var(--color-yellow)" class="circle" />
    </g>
  </svg>
  <svg id="icon-ai-deep-learning" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-ai-deep-learning" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.51 62.71">
    <title id="title-icon-ai-deep-learning">Ai Deep Learning icon</title>
    <desc id="content-icon-ai-deep-learning">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="icon-deep-learning">
      <g id="Tracciato_255" data-name="Tracciato 255">
        <path d="M35,55l-1.08-.91a1.17,1.17,0,0,1-.13-1.63,1.15,1.15,0,0,1,1.09-.38L37,50.3a1.14,1.14,0,0,1,1.62.13,1.15,1.15,0,0,1-.13,1.62ZM31.6,51.76a1.13,1.13,0,0,1-.75-.28l-3-2.59a1.15,1.15,0,0,1-.14-1.62,1.17,1.17,0,0,1,1.63-.13l3,2.59a1.15,1.15,0,0,1-.74,2Zm9.15-2a1.15,1.15,0,0,1-.75-2l3-2.59a1.15,1.15,0,1,1,1.49,1.75l-3,2.59A1.12,1.12,0,0,1,40.75,49.74ZM25.5,46.58a1.1,1.1,0,0,1-.74-.28l-3.05-2.59A1.15,1.15,0,0,1,23.2,42l3.05,2.59a1.15,1.15,0,0,1-.75,2Zm21.35-2a1.15,1.15,0,0,1-.75-2l3-2.58a1.14,1.14,0,0,1,1.62.13,1.15,1.15,0,0,1-.13,1.62l-3,2.59A1.17,1.17,0,0,1,46.85,44.56ZM19.41,41.39a1.17,1.17,0,0,1-.75-.27l-3-2.59a1.15,1.15,0,1,1,1.49-1.75l3,2.59A1.14,1.14,0,0,1,20.28,41,1.12,1.12,0,0,1,19.41,41.39Zm33.54-2a1.14,1.14,0,0,1-.88-.4,1.15,1.15,0,0,1,.13-1.62l3-2.59a1.15,1.15,0,0,1,1.49,1.75l-3.05,2.59A1.17,1.17,0,0,1,53,39.38ZM13.31,36.21a1.15,1.15,0,0,1-.74-.27L9.52,33.35A1.15,1.15,0,0,1,11,31.59l3.05,2.6a1.15,1.15,0,0,1,.13,1.62A1.17,1.17,0,0,1,13.31,36.21Zm45.74-2a1.15,1.15,0,0,1-.75-2l1.9-1.61-2-1.62A1.15,1.15,0,0,1,58,27.34a1.16,1.16,0,0,1,1.62-.19l4.23,3.36-4,3.43A1.17,1.17,0,0,1,59.05,34.21ZM8.8,31.06a1.15,1.15,0,0,1-.72-2l3.13-2.5a1.15,1.15,0,0,1,1.43,1.8L9.51,30.8A1.13,1.13,0,0,1,8.8,31.06Zm47-4.34a1.23,1.23,0,0,1-.72-.25L51.9,24a1.16,1.16,0,0,1-.18-1.62,1.14,1.14,0,0,1,1.61-.18l3.14,2.48a1.16,1.16,0,0,1,.18,1.62A1.14,1.14,0,0,1,55.75,26.72Zm-40.7-.65a1.18,1.18,0,0,1-.9-.43A1.16,1.16,0,0,1,14.34,24l3.13-2.49a1.15,1.15,0,0,1,1.43,1.8l-3.13,2.49A1.13,1.13,0,0,1,15.05,26.07Zm34.44-4.33a1.13,1.13,0,0,1-.72-.25L45.64,19a1.15,1.15,0,1,1,1.43-1.8l3.13,2.49a1.15,1.15,0,0,1-.71,2Zm-28.18-.65A1.15,1.15,0,0,1,20.6,19l3.12-2.49a1.15,1.15,0,0,1,1.44,1.8L22,20.84A1.15,1.15,0,0,1,21.31,21.09Zm21.91-4.33a1.12,1.12,0,0,1-.71-.25L39.38,14a1.15,1.15,0,0,1-.19-1.61,1.16,1.16,0,0,1,1.62-.19l3.13,2.49a1.15,1.15,0,0,1-.72,2.05Zm-15.65-.65a1.14,1.14,0,0,1-.9-.44,1.15,1.15,0,0,1,.18-1.61L30,11.56a1.15,1.15,0,0,1,1.44,1.8l-3.13,2.5A1.21,1.21,0,0,1,27.57,16.11ZM37,11.78a1.17,1.17,0,0,1-.72-.25l-1.26-1-.43.34a1.15,1.15,0,0,1-1.44-1.8L35,7.59l2.7,2.14a1.15,1.15,0,0,1-.72,2Z" style="fill:#161615" />
      </g>
      <g id="Linea_75" data-name="Linea 75">
        <path d="M62,31.69a1.15,1.15,0,0,1,0-2.3h0a1.15,1.15,0,1,1,0,2.3Zm-3,0H56a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,1,1,0,2.3Zm-6,0H50a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,1,1,0,2.3Zm-6,0H44a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,1,1,0,2.3Zm-6,0H38a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,1,1,0,2.3Zm-6,0H32a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,0,1,0,2.3Zm-6,0H26a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,0,1,0,2.3Zm-6,0H20a1.15,1.15,0,1,1,0-2.3h3a1.15,1.15,0,1,1,0,2.3Zm-6,0H14a1.15,1.15,0,0,1,0-2.3h3a1.15,1.15,0,1,1,0,2.3Zm-6,0H8a1.15,1.15,0,0,1,0-2.3h3a1.15,1.15,0,0,1,0,2.3Z" style="fill:#161615" />
      </g>
      <g id="Ellisse_99" data-name="Ellisse 99">
        <circle cx="62.01" cy="30.54" r="6.43" style="fill:#ff7575" />
      </g>
      <g id="Ellisse_100" data-name="Ellisse 100">
        <circle cx="8" cy="30.54" r="6.43" style="fill:#ffba00" />
      </g>
      <g id="Ellisse_101" data-name="Ellisse 101">
        <circle cx="34.98" cy="9.06" r="6.43" style="fill:#5738ff" />
      </g>
      <g id="Ellisse_102" data-name="Ellisse 102">
        <circle cx="34.98" cy="30.54" r="6.43" style="fill:#3abdbf" />
      </g>
      <g id="Tracciato_333" data-name="Tracciato 333">
        <path d="M35,47.05a6.43,6.43,0,1,1-6.43,6.43A6.43,6.43,0,0,1,35,47.05Z" style="fill:#885df1" />
      </g>
    </g>
  </svg>
  <svg id="icon-ai-computer-vision" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-ai-computer-vision" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.51 62.71">
    <title id="title-icon-ai-computer-vision">Ai Computer Vision icon</title>
    <desc id="content-icon-ai-computer-vision">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="icon-computer-vision">
      <path id="Tracciato_379" data-name="Tracciato 379" d="M60.34,3.67a2.8,2.8,0,0,1,2.8,2.8h0V14.4a1.4,1.4,0,1,1-2.8,0V6.47H52.41a1.4,1.4,0,1,1,0-2.8h7.93Z" style="fill:#3abdbf" />
      <path id="Tracciato_380" data-name="Tracciato 380" d="M6.71,46.57A1.4,1.4,0,0,1,8.11,48V55.9H16a1.4,1.4,0,0,1,0,2.8H8.11a2.8,2.8,0,0,1-2.8-2.8h0V48A1.4,1.4,0,0,1,6.71,46.57Z" style="fill:#5738ff" />
      <path id="Tracciato_381" data-name="Tracciato 381" d="M16,3.67a1.4,1.4,0,1,1,0,2.8H8.11V14.4a1.4,1.4,0,1,1-2.8,0h0V6.47a2.8,2.8,0,0,1,2.8-2.8H16Z" style="fill:#885df1" />
      <path id="Tracciato_382" data-name="Tracciato 382" d="M61.74,46.57a1.4,1.4,0,0,1,1.4,1.4V55.9a2.8,2.8,0,0,1-2.8,2.8H52.41a1.4,1.4,0,1,1,0-2.8h7.93V48A1.4,1.4,0,0,1,61.74,46.57Z" style="fill:#ffba00" />
      <circle id="Ellisse_152" data-name="Ellisse 152" cx="34.88" cy="30.93" r="7.97" style="fill:#885df1" />
      <g id="Raggruppa_287" data-name="Raggruppa 287">
        <path id="Tracciato_383" data-name="Tracciato 383" d="M34.23,15.54a1.71,1.71,0,0,1,0,3.41A12.24,12.24,0,1,0,46.47,31.18a1.71,1.71,0,0,1,3.41,0A15.65,15.65,0,1,1,34.23,15.54Z" style="fill:#ff7575" />
        <circle id="Ellisse_153" data-name="Ellisse 153" cx="34.88" cy="30.93" r="4.55" style="fill:#3abdbf" />
      </g>
      <circle id="Ellisse_154" data-name="Ellisse 154" cx="39.43" cy="18.13" r="1.71" style="fill:#ffba00" />
      <path id="Tracciato_384" data-name="Tracciato 384" d="M45.29,20.12a15.7,15.7,0,0,1,3.19,4.59,1.71,1.71,0,0,1-3.11,1.41h0a12.37,12.37,0,0,0-2.49-3.59,1.7,1.7,0,0,1,2.41-2.41Z" style="fill:#5738ff" />
    </g>
  </svg>
  <svg id="icon-ai-nlp" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-ai-nlp" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.51 62.71">
    <title id="title-icon-ai-nlp">Ai Nlp icon</title>
    <desc id="content-icon-ai-nlp">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="nlp">
      <path id="Tracciato_237" data-name="Tracciato 237" d="M63.1,30a27.87,27.87,0,0,0-.54-5.47,1.36,1.36,0,1,0-2.67.49V25a24.77,24.77,0,0,1-19.37,29.2,24,24,0,0,1-2.66.39l.76-.64a1.16,1.16,0,1,0-1.44-1.81l0,0-3.7,3.06h0l-.1.1-.06.07h0l0,.07-.08.12a.51.51,0,0,1,0,.1s0,.07,0,.11,0,.08,0,.12,0,.07,0,.1v.22s0,.07,0,.11l0,.11s0,.08,0,.11a.93.93,0,0,0,0,.1.38.38,0,0,0,.09.13l0,.05h0a1,1,0,0,0,.18.18h0L37.18,60a1.16,1.16,0,0,0,1.49-1.78l-.06,0-1-.8A27.49,27.49,0,0,0,63.1,30Z" style="fill:#ffba00" />
      <path id="Tracciato_238" data-name="Tracciato 238" d="M26.11,52.93c-.75-.32-1.5-.68-2.22-1.07A24.75,24.75,0,0,1,12.5,21.52l.22,1a1.15,1.15,0,0,0,1.13.91,1.07,1.07,0,0,0,.25,0A1.16,1.16,0,0,0,15,22l-1-4.7h0a.56.56,0,0,0,0-.12l0-.1h0l0-.06a.57.57,0,0,0-.08-.13l-.06-.08-.08-.09-.09-.07-.09-.07-.09,0-.12-.06-.07,0-.14,0h-.45l-.12,0-.1,0h0L8.05,18.47a1.16,1.16,0,0,0,1,2.11l1.14-.52A27.47,27.47,0,0,0,22.6,54.24c.8.43,1.63.83,2.46,1.18a1.4,1.4,0,0,0,.53.11,1.35,1.35,0,0,0,.52-2.6Z" style="fill:#ff7575" />
      <path id="Tracciato_239" data-name="Tracciato 239" d="M19.6,11.14A25.67,25.67,0,0,1,22,9.35a24.79,24.79,0,0,1,33.31,5.36l-1-.3a1.16,1.16,0,0,0-.66,2.22L58.2,18h0l.18,0h.12a.71.71,0,0,0,.2,0h.06l.13,0L59,18l.11-.06.07,0,.1-.07a.12.12,0,0,1,0-.05l.09-.1,0-.05a.56.56,0,0,0,.1-.15l0,0,.06-.16h0a.45.45,0,0,0,0-.16s0,0,0-.07h0l.37-4.7a1.16,1.16,0,0,0-2.31-.18l-.1,1.24A27.5,27.5,0,0,0,20.46,7.1a26.56,26.56,0,0,0-2.62,2,1.35,1.35,0,0,0,1.76,2.05Z" style="fill:#5738ff" />
      <g id="Raggruppa_100" data-name="Raggruppa 100">
        <path id="Tracciato_240" data-name="Tracciato 240" d="M37.28,37.57h0a20.08,20.08,0,0,1-8.87-2.13,8,8,0,0,1-5.3,2.13,1.27,1.27,0,1,1,0-2.53,5.24,5.24,0,0,0,3.1-1.11,6.65,6.65,0,0,1-2.52-5,1.26,1.26,0,0,1,1.27-1.26h0a1.26,1.26,0,0,1,1.26,1.27A4.31,4.31,0,0,0,28,32.13,17.59,17.59,0,0,0,31,22.81H23.08a1.27,1.27,0,1,1,0-2.53h8V17.86a1.27,1.27,0,1,1,2.53,0v2.42H36a1.27,1.27,0,0,1,0,2.53H33.53a20,20,0,0,1-3.39,10.67A18.08,18.08,0,0,0,37.31,35a1.27,1.27,0,1,1,0,2.53Z" style="fill:#3abdbf" />
      </g>
      <g id="Raggruppa_101" data-name="Raggruppa 101">
        <path id="Tracciato_241" data-name="Tracciato 241" d="M48.89,44.94a1.26,1.26,0,0,1-1.15-.75l-1.3-2.93H36.61L35.3,44.19a1.27,1.27,0,0,1-2.32-1h0l7.38-16.6A1.32,1.32,0,0,1,42.15,26a1.29,1.29,0,0,1,.53.53l7.37,16.6a1.26,1.26,0,0,1-.64,1.67,1.29,1.29,0,0,1-.51.1ZM37.73,38.72h7.58L41.52,30.2Z" style="fill:#885df1" />
      </g>
    </g>
  </svg>
  <svg id="icon-ai-predictive" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-ai-predictive" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.51 62.71">
    <title id="title-icon-ai-predictive">Ai Predictive icon</title>
    <desc id="content-icon-ai-predictive">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="icon-predictive">
      <g id="Raggruppa_182" data-name="Raggruppa 182">
        <path d="M66.9,23.54A13.8,13.8,0,1,0,52.7,37.32l2.08,14.61a1.21,1.21,0,0,0,1.37,1l1.51-.21a1.22,1.22,0,0,0,1-1.38L56.63,36.86A13.82,13.82,0,0,0,66.9,23.54ZM53.1,34.09A10.56,10.56,0,1,1,63.65,23.53h0A10.55,10.55,0,0,1,53.1,34.09Z" style="fill:#5738ff" />
        <g id="Raggruppa_185" data-name="Raggruppa 185">
          <circle id="Ellisse_134" data-name="Ellisse 134" cx="9.71" cy="46.69" r="6.11" style="fill:#ffba00" />
        </g>
        <g id="Raggruppa_186" data-name="Raggruppa 186">
          <circle id="Ellisse_135" data-name="Ellisse 135" cx="41.19" cy="44.58" r="6.11" style="fill:#885df1" />
        </g>
        <g id="Raggruppa_197" data-name="Raggruppa 197">
          <g id="Raggruppa_190" data-name="Raggruppa 190">
            <path id="Tracciato_336" data-name="Tracciato 336" d="M9.72,47.75a1.05,1.05,0,0,1-1.06-1.06A1.1,1.1,0,0,1,8.9,46L11,43.52a1,1,0,0,1,1.48-.15,1.06,1.06,0,0,1,.15,1.49h0l-2.07,2.5A1.06,1.06,0,0,1,9.72,47.75Z" style="fill:#161615" />
          </g>
          <g id="Raggruppa_191" data-name="Raggruppa 191">
            <path id="Tracciato_337" data-name="Tracciato 337" d="M14.85,41.56a1.05,1.05,0,0,1-1-1.06,1,1,0,0,1,.24-.67l3.06-3.69a1.06,1.06,0,1,1,1.63,1.35h0l-3.06,3.69A1.07,1.07,0,0,1,14.85,41.56Z" style="fill:#161615" />
          </g>
          <g id="Raggruppa_192" data-name="Raggruppa 192">
            <path id="Tracciato_338" data-name="Tracciato 338" d="M21,34.18a1.06,1.06,0,0,1-.81-1.73l2.72-3.28,3.39,2.6a1.05,1.05,0,0,1,.19,1.48,1.07,1.07,0,0,1-1.49.2h0l-1.77-1.37L21.79,33.8A1,1,0,0,1,21,34.18Z" style="fill:#161615" />
          </g>
          <g id="Raggruppa_193" data-name="Raggruppa 193">
            <path id="Tracciato_339" data-name="Tracciato 339" d="M34.29,40.32a1,1,0,0,1-.65-.22l-4.32-3.33A1.05,1.05,0,1,1,30.6,35.1l4.33,3.33a1.05,1.05,0,0,1-.64,1.89Z" style="fill:#161615" />
          </g>
          <g id="Raggruppa_194" data-name="Raggruppa 194">
            <path id="Tracciato_340" data-name="Tracciato 340" d="M41.51,46.15,38,43.43A1,1,0,0,1,37.75,42a1.07,1.07,0,0,1,1.48-.23l0,0L40.88,43l1-1.77a1.05,1.05,0,1,1,1.83,1.05h0Z" style="fill:#161615" />
          </g>
          <g id="Raggruppa_195" data-name="Raggruppa 195">
            <path id="Tracciato_341" data-name="Tracciato 341" d="M45.7,37.78a1.07,1.07,0,0,1-.52-.14,1.05,1.05,0,0,1-.39-1.44h0l2.89-5a1.05,1.05,0,0,1,1.43-.43,1.07,1.07,0,0,1,.43,1.43l0,.05-2.89,5A1.06,1.06,0,0,1,45.7,37.78Z" style="fill:#161615" />
          </g>
          <g id="Raggruppa_196" data-name="Raggruppa 196">
            <path id="Tracciato_342" data-name="Tracciato 342" d="M51.48,27.7a1,1,0,0,1-.52-.14,1,1,0,0,1-.39-1.44l1.61-2.82A1.07,1.07,0,0,1,53.64,23,1.06,1.06,0,0,1,54,24.36L52.4,27.17A1,1,0,0,1,51.48,27.7Z" style="fill:#161615" />
          </g>
        </g>
        <g id="Raggruppa_198" data-name="Raggruppa 198">
          <circle id="Ellisse_136" data-name="Ellisse 136" cx="53.1" cy="23.83" r="6.11" style="fill:#3abdbf" />
        </g>
        <g id="Raggruppa_199" data-name="Raggruppa 199">
          <circle id="Ellisse_137" data-name="Ellisse 137" cx="23.05" cy="30.63" r="6.11" style="fill:#ff7575" />
        </g>
      </g>
    </g>
  </svg>
  <svg id="icon-ai-data-visualization" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-ai-data-visualization" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.51 62.71">
    <title id="title-icon-ai-data-visualization">Ai Data Visualization icon</title>
    <desc id="content-icon-ai-data-visualization">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="icon-data-visualization">
      <path id="Tracciato_257" data-name="Tracciato 257" d="M8.44,5.28V57.43H62.06" style="fill:none;stroke:#161615;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px" />
      <circle id="Ellisse_104" data-name="Ellisse 104" cx="29.77" cy="18.88" r="8.7" style="fill:#ff7575" />
      <circle id="Ellisse_105" data-name="Ellisse 105" cx="31.08" cy="45.3" r="6.32" style="fill:#ffba00" />
      <circle id="Ellisse_106" data-name="Ellisse 106" cx="16.65" cy="42.68" r="2.72" style="fill:#5738ff" />
      <circle id="Ellisse_107" data-name="Ellisse 107" cx="42.56" cy="32.39" r="3.65" style="fill:#3abdbf" />
      <circle id="Ellisse_108" data-name="Ellisse 108" cx="49.78" cy="15.98" r="3.65" style="fill:#885df1" />
    </g>
  </svg>
  <svg id="icon-ai-decision-support-system" xml:space="preserve" preserveAspectRatio="xMidYMid" role="img" aria-labelledby="title-icon-ai-decision-support-system" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <title id="title-icon-ai-decision-support-system">Ai Decision Support System icon</title>
    <desc id="content-icon-ai-decision-support-system">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</desc>
    <g id="dss">
      <circle cx="18.63" cy="23.15" r="2.08" style="fill:#5738ff" />
      <circle cx="26.47" cy="23.15" r="2.08" style="fill:#5738ff" />
      <path d="M22.55,10.76a.9.9,0,0,0,.9-.9V8a.9.9,0,1,0-1.8,0V9.86A.9.9,0,0,0,22.55,10.76Z" style="fill:#fab90d" />
      <path d="M17,11.7l1.65,1a.81.81,0,0,0,.43.14.78.78,0,0,0,.75-.43.9.9,0,0,0-.33-1.22l-1.65-1a.92.92,0,0,0-1.23.33A.94.94,0,0,0,17,11.7Z" style="fill:#ed7476" />
      <path d="M26,12.74a.7.7,0,0,0,.42-.14l1.66-.94a.93.93,0,0,0,.33-1.23.91.91,0,0,0-1.23-.33L25.52,11a.93.93,0,0,0-.33,1.23A.89.89,0,0,0,26,12.74Z" style="fill:#2eb5b8" />
      <path d="M29,16.9H16.12a2.69,2.69,0,0,0-2.69,2.69V30.18a2.69,2.69,0,0,0,2.69,2.69H28.93a2.69,2.69,0,0,0,2.69-2.69h.05V19.59A2.69,2.69,0,0,0,29,16.9Z" style="fill:none" />
      <path d="M37.1,15.67a1,1,0,1,0-1-1A1,1,0,0,0,37.1,15.67Z" style="fill:none" />
      <rect x="11.62" y="25.78" width="0.06" height="2.17" style="fill:none" />
      <rect x="11.62" y="21.86" width="0.06" height="2.17" style="fill:none" />
      <path d="M42.16,23.89a1,1,0,1,0,0,2,1,1,0,0,0,0-2Z" style="fill:none" />
      <path d="M37.1,36.08a1,1,0,0,0,1-1,1,1,0,1,0-1,1Z" style="fill:none" />
      <path d="M2.84,23.89a1,1,0,0,0,0,2,1.07,1.07,0,0,0,1-1A1,1,0,0,0,2.84,23.89Z" style="fill:#fff" />
      <path d="M7.9,13.69a1,1,0,0,0-1,1,1,1,0,1,0,1-1Z" style="fill:#fff" />
      <path d="M7.9,28a.9.9,0,0,0-.9.9v3.68a2.77,2.77,0,1,0,3.69,2.55,2.76,2.76,0,0,0-1.89-2.6V29.71h2.82V28Zm1,7.13a1,1,0,1,1-1-1A1,1,0,0,1,8.89,35.09Z" style="fill:#3abdbf" />
      <path d="M2.84,22.15A2.78,2.78,0,0,0,.06,24.93a2.72,2.72,0,0,0,2.78,2.74,2.75,2.75,0,0,0,2.6-1.89h6.18V24H5.44A2.8,2.8,0,0,0,2.84,22.15Zm0,3.73a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1.07,1.07,0,0,1,2.84,25.88Z" style="fill:#ffba00" />
      <path d="M8.8,17.28a2.77,2.77,0,0,0-.9-5.39A2.77,2.77,0,0,0,7,17.28V21a.9.9,0,0,0,.9.9h3.72V20.07H8.8Zm-.9-1.61a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,0,2Z" style="fill:#ec7e79" />
      <path d="M29,16.9H16.12a2.69,2.69,0,0,0-2.69,2.69V30.18a2.69,2.69,0,0,0,2.69,2.69H28.93a2.69,2.69,0,0,0,2.69-2.69h.05V19.59A2.69,2.69,0,0,0,29,16.9Z" style="fill:none" />
      <path d="M33.42,27.91V19.64A4.44,4.44,0,0,0,29,15.2H23.45V13.31a.9.9,0,1,0-1.8,0V15.2H16.12a4.43,4.43,0,0,0-4.44,4.44v.43h-.06v1.79h.06V24h-.06v1.74h.06V28h-.06v1.75h.06v.42a4.43,4.43,0,0,0,4.44,4.44H29a4.44,4.44,0,0,0,4.45-4.44V27.91Zm-1.75,2.27h-.05a2.69,2.69,0,0,1-2.69,2.69H16.12a2.69,2.69,0,0,1-2.69-2.69V19.59a2.69,2.69,0,0,1,2.69-2.69H29a2.69,2.69,0,0,1,2.7,2.69Z" style="fill:#885df1" />
      <path d="M42.16,25.88a1,1,0,0,0,0-2,1,1,0,1,0,0,2Z" style="fill:#fff" />
      <path d="M37.1,15.67a1,1,0,1,0-1-1A1,1,0,0,0,37.1,15.67Z" style="fill:#fff" />
      <path d="M39.56,25.78a2.76,2.76,0,0,0,5.38-.89,2.76,2.76,0,0,0-5.38-.9H33.42v1.79Zm2.6-1.89a1,1,0,1,1-1,1A1,1,0,0,1,42.16,23.89Z" style="fill:#ffba00" />
      <path d="M37.1,21.81a.89.89,0,0,0,.9-.89V17.28a2.77,2.77,0,1,0-3.69-2.6,2.76,2.76,0,0,0,1.89,2.6v2.79H33.42v1.74Zm-1-7.13a1,1,0,1,1,1,1A1,1,0,0,1,36.11,14.68Z" style="fill:#ec7e79" />
      <path d="M36.2,29.71v2.78a2.77,2.77,0,1,0,3.69,2.6A2.75,2.75,0,0,0,38,32.49V28.81a.9.9,0,0,0-.9-.9H33.42v1.8Zm.9,4.39a1,1,0,0,1,1,1,1,1,0,0,1-1,1,1,1,0,1,1,0-2Z" style="fill:#3abdbf" />
      <path d="M22.66,31.77a8.41,8.41,0,0,1-5.82-2.59,1,1,0,0,1,1.37-1.46,6.47,6.47,0,0,0,4.6,2.05,7,7,0,0,0,4.35-2,1,1,0,0,1,1.46,1.36,8.85,8.85,0,0,1-5.73,2.64Z" style="fill:#5738ff" />
    </g>
  </svg>
</section>
</template>

)

<script>
export default {
  name: 'CommonIcons',
  data() {
    return {
      viewbox: '0 0 500 500'
    }
  }
};
</script>

<style lang="scss" scoped>
.CommonIcons {
  display: none;
}

#icon-ai-and-machine-learning {
  .shape-0 {
    fill: var(--color-purple);
  }

  .shape-1 {
    fill: var(--color-red);
  }

  .shape-2 {
    fill: var(--color-blue);
  }

  .shape-3 {
    fill: var(--color-light-blue);
  }

  .shape-4 {
    fill: var(--color-yellow);
  }

  .shape-5 {
    fill: var(--color-yellow-light);
  }
}

#icon-cloud-service {
  .shape-0 {
    stroke: var(--color-black);
    stroke-width: 0.25;
    stroke-miterlimit: 10;
  }

  .shape-1 {
    fill-opacity: 0;
    stroke: var(--color-black);
    stroke-width: 5.25;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 31.5, 26.25;
  }

  .shape-2 {
    fill: var(--color-red);
  }

  .shape-3 {
    fill: var(--color-yellow);
  }

  .shape-4 {
    fill: var(--color-purple);
  }

  .shape-5 {
    fill: var(--color-light-blue);
  }
}

#icon-digital-marketing-solutions {
  .shape-0 {
    fill: none;
    stroke: var(--color-black);
    stroke-width: 1.7677;
    stroke-linejoin: round;
  }

  .shape-1 {
    fill: none;
    stroke: var(--color-black);
    stroke-width: 1.8374;
    stroke-linejoin: round;
  }

  .shape-2 {
    fill: none;
    stroke: var(--color-black);
    stroke-width: 2.1682;
    stroke-linejoin: round;
  }

  .shape-3 {
    fill: var(--color-blue);
  }

  .shape-4 {
    fill: var(--color-light-blue);
  }

  .shape-5 {
    fill: var(--color-red);
  }

  .shape-6 {
    fill: var(--color-yellow);
  }
}

#icon-mobile-development {
  .shape-0 {
    fill: var(--color-light-blue);
  }

  .shape-1 {
    fill: var(--color-blue);
  }

  .shape-2 {
    fill: var(--color-yellow);
    enable-background: new;
  }
}

#icon-project-and-product-management {
  .shape-0 {
    fill: var(--color-yellow);
  }

  .shape-1 {
    fill: var(--color-red);
  }

  .shape-2 {
    fill: var(--color-light-blue);
  }
}

#icon-quality-assurance {
  .shape-0 {
    fill: var(--color-red);
  }

  .shape-1 {
    fill: var(--color-light-blue);
  }
}

#icon-strategic-consulting {
  .shape-0 {
    fill: var(--color-yellow);
  }

  .shape-1 {
    fill-opacity: 0;
    stroke: var(--color-blue-dark);
    stroke-width: 3.5;
    stroke-miterlimit: 10;
    stroke-dasharray: 20.9999, 17.4999;
  }

  .shape-2 {
    fill: var(--color-light-blue);
  }

  .shape-3 {
    fill: var(--color-red);
  }
}

#icon-web-development {
  .shape-0 {
    fill: var(--color-light-blue);
  }

  .shape-1 {
    fill: var(--color-yellow);
    enable-background: new;
  }

  .shape-2 {
    fill: var(--color-blue);
  }
}

.animation-approach-understand {
  .level {
    opacity: 0;
    transform-origin: 50% 50%;
  }

  .level-1 {
    transform: rotate(-135deg)
  }

  .level-2 {
    transform: rotate(135deg)
  }

  .level-3 {
    transform: rotate(-135deg)
  }

  .level-4 {
    transform: rotate(135deg)
  }

  .level-5 {
    transform: scale(.5)
  }

  &.visible {
    .level {
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;
      transform: rotate(0) scale(1);
    }

    .level-1 {
      transition-delay: .4s
    }

    .level-2 {
      transition-delay: .7s
    }

    .level-3 {
      transition-delay: 1s
    }

    .level-4 {
      transition-delay: 1.3s
    }

    .level-5 {
      transition-delay: 1.6s
    }
  }
}

.animation-approach-improve {
  .level {
    opacity: 0;
    transform-origin: 50% 50%;
  }

  .yellow,
  .green,
  .blue {
    transform: scale(.5)
  }

  .red,
  .purple {
    transform: rotate(-45deg) scale(.75)
  }

  &.visible {
    .level {
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;
      transform: rotate(0) scale(1);
    }

    .yellow {
      transition-delay: .4s
    }

    .red {
      transition-delay: .7s
    }

    .purple {
      transition-delay: 1s
    }

    .green {
      transition-delay: 1.3s
    }

    .blue {
      transition-delay: 1.6s
    }
  }
}

.animation-approach-support {
  .level {
    opacity: 0;
  }

  .level-1 {
    transform: translate(25%, 22%)
  }

  .level-2 {
    transform: translate(0, 22%)
  }

  .level-3 {
    transform: translate(-27%, 22%)
  }

  .level-4 {
    transform: translate(-52%, 22%)
  }

  .level-5 {
    transform: translate(25%, 0)
  }

  .level-6 {
    transform: translate(-27%, 0)
  }

  .level-7 {
    transform: translate(25%, -24%)
  }

  .level-8 {
    transform: translate(25%, -46%)
  }

  .level-9 {
    transform: translate(0%, -24%)
  }

  .level-11 {
    perspective: 1000px;

    path {
      opacity: 0;
      transform: rotateX(103deg);
      transform-origin: 50% 100%;
      backface-visibility: hidden;
    }
  }

  &.visible {
    .level {
      transition: all .8s ease-in-out;
      opacity: 1;
      transform: translate(0, 0);
    }

    .level-1 {
      transition-delay: .4s
    }

    .level-2 {
      transition-delay: .5s
    }

    .level-3 {
      transition-delay: .6s
    }

    .level-4 {
      transition-delay: .7s
    }

    .level-5 {
      transition-delay: .8s
    }

    .level-6 {
      transition-delay: .9s
    }

    .level-7 {
      transition-delay: 1s
    }

    .level-8 {
      transition-delay: 1.1s
    }

    .level-9 {
      transition-delay: 1.2s
    }

    .level-10 {
      transition-delay: 1.3s
    }

    .level-11 {
      path {
        opacity: 1;
        transform: rotateX(0deg);
        transition: opacity .3s ease-in-out 1.4s, transform .8s cubic-bezier(.175, .885, .32, 1.275) 1.4s;
      }
    }
  }
}

.animation-approach-tailor {
  .line {
    stroke-dasharray: 1836;
    stroke-dashoffset: 1836;
  }

  .shape-blue {
    transform: scale(0, 1);
    transform-origin: 50% 50%;
  }

  .shape-yellow {
    transform: scale(1, 0);
    transform-origin: 50% 50%;
  }

  .shape-green {
    transform: scale(1, 0);
    transform-origin: 50% 100%;
  }

  .shape-red {
    transform-origin: 50% 0;
    opacity: 0;
    transform: scale(.5);
  }

  &.visible {
    .line {
      stroke-dashoffset: 0;
      transition: stroke-dashoffset 4s ease-in-out .4s;
    }

    .shape-red {
      opacity: 1;
      transform: scale(1, 1);
      transition: opacity .3s ease 1.3s, transform .8s cubic-bezier(.175, .885, .32, 1.275);
    }

    .shape {
      transform: scale(1, 1);
      transition: transform .8s cubic-bezier(.175, .885, .32, 1.275);
    }

    .shape-blue {
      transition-delay: .4s
    }

    .shape-yellow {
      transition-delay: .8s
    }

    .shape-green {
      transition-delay: 1.4s
    }

    .shape-red {
      transition-delay: 2s
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(.5);
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  99% {
    transform: scale(1);
    opacity: 0;
  }

  100% {
    transform: scale(.5);
    opacity: 1;
  }
}

.animation-approach-identify {
  .line {
    opacity: 0;
  }

  .shape {
    opacity: 0;
  }

  .shape-2 {
    transform: translate(32%, 0)
  }

  .shape-3 {
    transform: translate(32%, -45%)
  }

  .shape-4 {
    transform: translate(10%, -45%)
  }

  .shape-5 {
    transform: translate(10%, 45%)
  }

  .shape-6 {
    transform: translate(-13%, 45%)
  }

  .shape-7 {
    transform: translate(-12%, 0)
  }

  .pulse {
    transform-origin: 92.25% 50.08%;
    animation: pulse 1.5s infinite;
  }

  &.visible {
    .line {
      opacity: 1;
      transition: opacity .2s ease-in-out;
    }

    .shape {
      transform: translate(0, 0);
      transition: all .8s ease-in-out .4s;
      opacity: 1;
    }

    .shape-2 {
      transition-delay: .4s
    }

    .shape-3 {
      transition-delay: .5s
    }

    .shape-4 {
      transition-delay: .6s
    }

    .shape-5 {
      transition-delay: 1.1s
    }

    .shape-6 {
      transition-delay: 1.2s
    }

    .shape-7 {
      transition-delay: 1.5s
    }

    @for $i from 1 to 41 {
      .line-#{$i} {
        transition-delay: (.4s + (.05s * $i));
      }
    }
  }
}

.animation-finance {
  .yellow-box {
    opacity: 0;
  }

  .red-box {
    opacity: 0;
    transform: scale(1, 0);
  }

  .purple-box {
    opacity: 0;
  }

  .green-box {
    opacity: 0;
    transform: scale(1, 0);
  }

  .blue-box {
    opacity: 0;
  }

  &.visible {
    .yellow-box {
      opacity: 1;
      transition: all .3s ease-in-out;
      animation: upDownYellow 1s infinite alternate;

    }

    .red-box {
      opacity: 1;
      transition: all .3s ease-in-out;
      animation: upDownRed 1s infinite alternate-reverse;
    }

    .purple-box {
      opacity: 1;
      transition: all .3s ease-in-out;
      animation: upDownPurple 1s infinite alternate;
    }

    .green-box {
      opacity: 1;
      transition: all .3s ease-in-out;
      animation: upDownGreen 1s infinite alternate-reverse;
    }

    .blue-box {
      opacity: 1;
      transition: all .3s ease-in-out;
      animation: upDownBlue 1s infinite alternate;
    }
  }

  @keyframes upDownYellow {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-50px);
    }
  }

  @keyframes upDownRed {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-10px);
    }
  }

  @keyframes upDownPurple {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(30px);
    }
  }

  @keyframes upDownGreen {
    0% {
      transform: translateY(-10px);
    }

    100% {
      transform: translateY(18px);
    }
  }

  @keyframes upDownBlue {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(40px);
    }
  }
}

.animation-retail {
  transform: rotate(20deg) translateX(-100px);

  .red-triangle {
    opacity: 0;
    transform: scale(1, 0);
    transform-origin: 50% 100%;
  }

  .purple-box {
    opacity: 0;
    transform: scale(0, 0);
    transform-origin: 100% 50%;
  }

  .yellow-circle {
    opacity: 0;
    transform: scale(.5);
    transform-origin: 50% 50%;
  }

  .blue-circle,
  .green-circle {
    opacity: 0;
  }

  &.visible {
    transform: rotate(0deg) translateX(0);
    transition: all .8s ease-in-out;

    .red-triangle {
      opacity: 1;
      transform: scale(1, 1);
      transition: all .3s ease-in-out;
    }

    .purple-box {
      opacity: 1;
      transform: scale(1, 1);
      transition: opacity .5s ease-in-out;
    }

    .yellow-circle {
      transform: scale(1);
      transform-origin: center;
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;

    }

    .green-circle,
    .blue-circle {
      opacity: 1;
      transform-origin: center;
      animation: rotate .6s infinite;
      transform-box: fill-box;
    }

    @keyframes rotate {
      from {
        transform: rotateZ(0deg)
      }

      to {
        transform: rotateZ(360deg)
      }
    }
  }
}

.animation-industry {
  .blue-element {
    opacity: 0;
  }

  .purple-circle {
    opacity: 0;
    transform: translateX(-200px);
  }

  .green-circle {
    opacity: 0;
    transform: translateX(-180px);
  }

  .red-circle {
    opacity: 0;
    transform: translateX(-180px) scale(0.5);
  }

  .yellow-circle {
    opacity: 0;
    transform: translateX(-150px);
  }

  .first-purple-circle {
    opacity: 0;
    transform: translateX(-150px);
  }

  &.visible {
    .blue-element {
      opacity: 1;
      animation: slideDown 2s 1;
      transition: all .6s ease;
    }

    .first-purple-circle {
      opacity: 1;
      transform: translateX(0px);
      transition: all .8s ease;
    }

    .yellow-circle {
      opacity: 1;
      transform: translateX(0);
      transition: all .7s ease;
    }

    .red-circle {
      opacity: 1;
      transform-origin: center;
      transform: translateX(0px) scale(1);
      transition: all .8s ease;
    }

    .green-circle {
      opacity: 1;
      transform: translateX(0);
      transition: all .5s ease;
    }

    .purple-circle {
      opacity: 1;
      transform: translateX(0px);
      transition: all .4s ease;
    }

  }

  @keyframes slideDown {
    0% {
      transform: translateY(-70px);
    }

    50% {
      transform: translateY(15px);
    }

    100% {
      transform: translateY(0px);
    }
  }
}

.animation-health-care {
  .circle {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(.5);
  }

  .small-circle {
    opacity: 0;
    transform: rotate(-90deg) scale(.75)
  }

  .shape {
    transform: scale(0, 1);
    transform-origin: 50% 50%;
  }

  &.visible {
    .circle {
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;
      transform: scale(1);

      &.big-yellow-circle {
        transition-delay: .3s
      }

      &.big-green-circle {
        transition-delay: .4s
      }

      &.big-red-circle {
        transition-delay: .5s
      }
    }

    .small-circle {
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;
      transform: rotate(0);
    }

    .shape {
      transform: scale(1, 1);
      transition: transform .8s cubic-bezier(.175, .885, .32, 1.275);
    }

  }
}

.animation-marketing {
  .circle {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(.5);
  }

  .rotate {
    opacity: 0;
    transform: rotate(90deg);
    transform-origin: 50% 50%;
  }

  &.visible {
    .rotate {
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;
      transform: rotate(0);
    }

    .circle {
      transition: all .8s cubic-bezier(.175, .885, .32, 1.275);
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
